import React from "react";
import ZapierImage from "./logos/zapier.jpg";
import ClayImage from "./logos/Clay.png";
import InstagramImage from "./logos/Instagram.png";

// Define the base props for SVG logos
interface SvgLogoProps extends React.SVGProps<SVGSVGElement> {
  children?: React.ReactNode;
  size?: number;
}

// Unified props type for individual logo components
type LogoComponentProps = Omit<SvgLogoProps, "children"> & {
  size?: number;
};

function SvgLogo({
  children,
  size,
  viewBox = "0 0 24 24",
  ...rest
}: SvgLogoProps & { viewBox?: string }) {
  const finalSize = size ?? 24;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={finalSize}
      height={finalSize}
      viewBox={viewBox}
      fill="none"
      {...rest}
    >
      {children}
    </svg>
  );
}

const ZoomInfoLogo = (props: LogoComponentProps) => {
  return (
    <SvgLogo {...props}>
      <path
        d="M21.3818 0H2.61818C1.14545 0 0 1.14545 0 2.61818V21.3818C0 22.8545 1.14545 24 2.61818 24H21.3818C22.8545 24 24 22.8545 24 21.3818V2.61818C24 1.14545 22.8545 0 21.3818 0ZM6.54545 6.76364C6.54545 6.65455 6.65455 6.54545 6.70909 6.54545H12.7636C12.8727 6.54545 12.9273 6.65455 12.9273 6.76364V7.47273C12.9273 7.58182 12.8182 7.69091 12.7636 7.69091H7.69091V9.38182C7.69091 9.49091 7.58182 9.6 7.52727 9.6H6.76364C6.65455 9.6 6.6 9.49091 6.6 9.38182V6.76364H6.54545ZM17.4545 17.2364C17.4545 17.3455 17.3455 17.4545 17.2909 17.4545H11.7273C11.6182 17.4545 11.5636 17.3455 11.5636 17.2364V16.4727C11.5636 16.3636 11.6727 16.2545 11.7273 16.2545H16.3091V14.5091C16.3091 14.4 16.4182 14.2909 16.5273 14.2909H17.2909C17.4 14.2909 17.4545 14.4 17.4545 14.5091V17.2364ZM17.4545 9.32727C17.4545 9.43636 17.3455 9.54545 17.2909 9.54545H16.5273C16.4182 9.54545 16.3091 9.43636 16.3091 9.32727V8.50909L8.23636 16.3091H9.87273C9.98182 16.3091 10.0909 16.4182 10.0909 16.5273V17.2909C10.0909 17.4 9.98182 17.5091 9.92727 17.5091H6.76364C6.65455 17.5091 6.54545 17.4 6.6 17.2909V16.3636L15.5455 7.74545H14.6182C14.5091 7.74545 14.4 7.63636 14.4545 7.52727V6.76364C14.4545 6.65455 14.5636 6.54545 14.6182 6.54545H17.2909C17.4 6.54545 17.4545 6.65455 17.4545 6.76364V9.32727Z"
        fill="#F44238"
      />
      <path
        d="M17.2906 14.3457H16.527C16.4179 14.3457 16.3088 14.4548 16.3088 14.5639V16.3093H11.727C11.6179 16.3093 11.5088 16.4184 11.5633 16.5275V17.2912C11.5633 17.4002 11.6724 17.5093 11.727 17.5093H17.2906C17.3997 17.5093 17.4542 17.4002 17.4542 17.2912V14.6184C17.4542 14.4548 17.3452 14.3457 17.2906 14.3457Z"
        fill="white"
      />
      <path
        d="M6.70939 9.54527H7.47303C7.58212 9.54527 7.63667 9.43618 7.63667 9.32709V7.63618H12.7094C12.8185 7.63618 12.873 7.52709 12.873 7.418V6.7089C12.873 6.59981 12.7639 6.49072 12.7094 6.49072H6.70939C6.6003 6.49072 6.49121 6.59981 6.54576 6.7089V9.32709C6.54576 9.43618 6.65485 9.54527 6.70939 9.54527Z"
        fill="white"
      />
      <path
        d="M17.2904 6.54541H14.6176C14.5086 6.54541 14.454 6.6545 14.454 6.76359V7.52723C14.454 7.63632 14.5631 7.74541 14.6176 7.74541H15.5449L6.54492 16.309V17.2363C6.54492 17.3454 6.65401 17.4545 6.70856 17.4545H9.8722C9.98129 17.4545 10.0904 17.3454 10.0358 17.2363V16.4727C10.0358 16.3636 9.92674 16.2545 9.81765 16.2545H8.18129L16.254 8.4545V9.27268C16.254 9.38177 16.3631 9.49086 16.4722 9.49086H17.2358C17.3449 9.49086 17.3995 9.38177 17.3995 9.27268V6.70905C17.454 6.6545 17.3449 6.54541 17.2904 6.54541Z"
        fill="white"
      />
    </SvgLogo>
  );
};

const DriveLogo = (props: LogoComponentProps) => {
  return (
    <SvgLogo {...props}>
      <path
        d="M24 15.4737H16.6602L9.37141 1H15.4571C15.868 1 16.246 1.22753 16.4458 1.59458L24 15.4737ZM11.4313 7.61737L3.83122 22.5368L0.176623 16.6547C-0.0469082 16.2946 -0.0593581 15.8378 0.145499 15.4662L8.09813 1L11.4313 7.61737ZM23.9774 16.6316L20.355 22.4633C20.1473 22.7974 19.7874 23 19.3998 23H4.87248L8.11511 16.6316H23.9774Z"
        fill="#202020"
      />
    </SvgLogo>
  );
};

const NotionLogo = (props: LogoComponentProps) => {
  return (
    <SvgLogo {...props}>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.7424 0.0547656L1.44588 1.03563C0.373185 1.12827 0 1.82834 0 2.66737V17.2256C0 17.8791 0.232369 18.4383 0.792987 19.1857L3.91856 23.2447C4.43208 23.8982 4.89898 24.0384 5.8794 23.9918L21.3203 23.0583C22.6259 22.9654 23 22.3582 23 21.332V4.95383C23 4.42343 22.7902 4.27056 22.1727 3.81792L17.8223 0.754597C16.7955 0.00892609 16.3757 -0.0853928 14.7424 0.0545256V0.0547656ZM6.22856 4.68575C4.96771 4.77047 4.68175 4.78967 3.96566 4.20816L2.14515 2.76193C1.96012 2.57474 2.05312 2.34122 2.5193 2.29466L15.3015 1.36179C16.375 1.26819 16.9339 1.64187 17.3537 1.96826L19.5459 3.55464C19.6397 3.60192 19.8727 3.88104 19.5923 3.88104L6.39196 4.67471L6.22856 4.68575ZM4.75865 21.192V7.28828C4.75865 6.68109 4.94536 6.40101 5.50429 6.35397L20.6657 5.46742C21.18 5.4211 21.4123 5.7475 21.4123 6.35373V20.1648C21.4123 20.772 21.3186 21.2856 20.4793 21.332L5.97072 22.1719C5.13135 22.2183 4.75889 21.9391 4.75889 21.192H4.75865ZM19.0805 8.03371C19.1735 8.45371 19.0805 8.8737 18.66 8.9217L17.9607 9.06018V19.3256C17.3534 19.652 16.7945 19.8384 16.3274 19.8384C15.5808 19.8384 15.3943 19.6049 14.8351 18.9056L10.2622 11.7201V18.6721L11.7088 18.9992C11.7088 18.9992 11.7088 19.8392 10.5417 19.8392L7.32408 20.0256C7.23036 19.8385 7.32408 19.3721 7.65017 19.2793L8.49049 19.0465V9.85457L7.32432 9.76025C7.2306 9.34026 7.46369 8.73378 8.11731 8.68674L11.5697 8.45467L16.3276 15.7331V9.29394L15.1148 9.15474C15.0211 8.64042 15.3943 8.26675 15.8605 8.22115L19.0805 8.03371Z"
        fill="#202020"
      />
    </SvgLogo>
  );
};

const ZapierLogo = ({ size = 24 }: LogoComponentProps) => {
  return (
    <img
      src={typeof ZapierImage === "string" ? ZapierImage : ZapierImage.src}
      alt="Zapier"
      width={size}
      height={size}
      style={{ objectFit: "contain" }}
    />
  );
};

const OctalaneLogo = (props: LogoComponentProps) => {
  return (
    <SvgLogo {...props}>
      <g clip-path="url(#clip0_22_2878)">
        <mask
          id="mask0_22_2878"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="19"
          height="24"
        >
          <path
            d="M0.599609 0L18.3596 0.0479042L18.2636 24L0.599609 23.9521V0Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_22_2878)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13.5598 14.4187C12.7918 15.1372 11.5918 15.3768 10.6318 14.8498C9.86383 14.4187 9.28783 13.5564 9.28783 12.6462C9.28783 11.9756 9.52783 11.4007 9.86383 10.8259C10.2478 10.1073 10.6798 9.53245 11.1118 8.81388C11.4478 8.09532 11.7838 7.37676 11.8318 6.61029C12.0238 5.26897 11.5918 3.92766 11.0638 2.73005C10.8238 2.29891 10.5838 1.81987 10.3438 1.38873C10.1518 1.14921 10.0078 0.813883 9.81583 0.574362C9.57583 0.286937 9.38383 -0.000488281 9.09583 -0.000488281C8.95183 -0.000488281 8.85583 0.0474159 8.80783 0.0953201C8.66383 0.191129 8.56783 0.334841 8.56783 0.574362C8.56783 0.813883 8.61583 1.0534 8.61583 1.29293C8.61583 1.53245 8.61583 1.77197 8.56783 2.01149C8.51983 2.49053 8.37583 2.96957 8.27983 3.40071C8.13583 3.83185 7.89583 4.31089 7.70383 4.69412C7.51183 5.02945 7.31983 5.36478 7.03183 5.65221C5.87983 7.04143 4.34383 7.9037 3.09583 9.19712C1.22383 11.1133 0.311834 13.9875 0.695834 16.7181C0.743834 17.0534 0.839834 17.4366 0.935834 17.7241C2.32783 18.5384 3.95983 19.0654 5.68783 19.0654C9.71983 19.0654 13.3198 16.5265 14.6158 12.8378C14.3278 13.4606 13.9918 13.9875 13.5598 14.4187Z"
            fill="#E88323"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13.5598 14.4187C12.7918 15.1372 11.5918 15.3768 10.6318 14.8498C9.86383 14.4187 9.28783 13.5564 9.28783 12.6462C9.28783 11.9756 9.52783 11.4007 9.86383 10.8259C10.2478 10.1073 10.6798 9.53245 11.1118 8.81388C11.4478 8.09532 11.7838 7.37676 11.8318 6.61029C12.0238 5.26897 11.5918 3.92766 11.0638 2.73005C10.8238 2.29891 10.5838 1.81987 10.3438 1.38873C10.1518 1.14921 10.0078 0.813883 9.81583 0.574362C9.57583 0.286937 9.38383 -0.000488281 9.09583 -0.000488281C8.95183 -0.000488281 8.85583 0.0474159 8.80783 0.0953201C8.66383 0.191129 8.56783 0.334841 8.56783 0.574362C8.56783 0.813883 8.61583 1.0534 8.61583 1.29293C8.61583 1.53245 8.61583 1.77197 8.56783 2.01149C8.51983 2.49053 8.37583 2.96957 8.27983 3.40071C8.13583 3.83185 7.89583 4.31089 7.70383 4.69412C7.51183 5.02945 7.31983 5.36478 7.03183 5.65221C5.87983 7.04143 4.34383 7.9037 3.09583 9.19712C1.22383 11.1133 0.311834 13.9875 0.695834 16.7181C0.743834 17.0534 0.839834 17.4366 0.935834 17.7241C2.32783 18.5384 3.95983 19.0654 5.68783 19.0654C9.71983 19.0654 13.3198 16.5265 14.6158 12.8378C14.3278 13.4606 13.9918 13.9875 13.5598 14.4187Z"
            fill="url(#paint0_linear_22_2878)"
            fill-opacity="0.2"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M18.0238 13.9873C17.9278 13.3166 17.7838 12.6459 17.4958 12.0232C17.3038 11.5921 17.1118 11.2088 16.8718 10.7777C16.6798 10.5382 16.5358 10.2986 16.3438 10.0591C16.1518 9.8675 16.0558 9.58008 15.7198 9.58008C15.3838 9.58008 15.2398 9.8196 15.1918 10.107C15.0478 10.9214 14.9518 11.8316 14.6158 12.598C13.3198 16.2867 9.76784 18.8256 5.59184 18.8256C3.86384 18.8256 2.23184 18.3945 0.839844 17.5801C0.935844 17.9154 1.07984 18.2507 1.17584 18.5861C1.94384 20.4064 3.38384 21.9394 5.11184 22.8974C8.03984 24.4783 11.8318 24.1909 14.5198 22.2268C15.3838 21.604 16.1518 20.7897 16.7278 19.9274C17.3038 19.0651 17.6878 18.0591 17.9278 17.0531C18.1678 16.095 18.2158 14.9933 18.0238 13.9873Z"
            fill="#F8981D"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M18.0238 13.9873C17.9278 13.3166 17.7838 12.6459 17.4958 12.0232C17.3038 11.5921 17.1118 11.2088 16.8718 10.7777C16.6798 10.5382 16.5358 10.2986 16.3438 10.0591C16.1518 9.8675 16.0558 9.58008 15.7198 9.58008C15.3838 9.58008 15.2398 9.8196 15.1918 10.107C15.0478 10.9214 14.9518 11.8316 14.6158 12.598C13.3198 16.2867 9.76784 18.8256 5.59184 18.8256C3.86384 18.8256 2.23184 18.3945 0.839844 17.5801C0.935844 17.9154 1.07984 18.2507 1.17584 18.5861C1.94384 20.4064 3.38384 21.9394 5.11184 22.8974C8.03984 24.4783 11.8318 24.1909 14.5198 22.2268C15.3838 21.604 16.1518 20.7897 16.7278 19.9274C17.3038 19.0651 17.6878 18.0591 17.9278 17.0531C18.1678 16.095 18.2158 14.9933 18.0238 13.9873Z"
            fill="url(#paint1_linear_22_2878)"
            fill-opacity="0.4"
          />
        </g>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_22_2878"
          x1="7.59329"
          y1="-0.000488281"
          x2="7.59329"
          y2="19.0652"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" />
          <stop offset="1" stop-color="white" stop-opacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_22_2878"
          x1="9.52789"
          y1="9.59742"
          x2="9.52789"
          y2="23.9244"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" />
          <stop offset="1" stop-color="white" stop-opacity="0" />
        </linearGradient>
        <clipPath id="clip0_22_2878">
          <rect
            width="17.76"
            height="24"
            fill="white"
            transform="translate(0.599609)"
          />
        </clipPath>
      </defs>
    </SvgLogo>
  );
};

const ShopifyLogo = (props: LogoComponentProps) => {
  return (
    <SvgLogo {...props}>
      <g clip-path="url(#clip0_22_2890)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M15.3349 24.0804L15.2813 3.51586C15.1426 3.37734 14.8722 3.41917 14.7665 3.45003L14.0622 3.66808C13.9752 3.38232 13.8624 3.10506 13.7251 2.83974C13.2254 1.8866 12.495 1.3826 11.6109 1.38123H11.6081C11.5491 1.38123 11.4907 1.38671 11.4317 1.39151L11.4248 1.3922C11.3993 1.36074 11.3727 1.3301 11.3452 1.30031C10.9608 0.888884 10.4665 0.68797 9.87482 0.705113C8.73393 0.738027 7.59786 1.56226 6.67595 3.02626C6.02726 4.05688 5.53507 5.35083 5.39435 6.35266L3.14759 7.04866C2.48654 7.25643 2.46594 7.277 2.37877 7.90031C2.31355 8.37209 0.583008 21.7565 0.583008 21.7565L15.0864 24.2649L15.3349 24.0804ZM10.5832 1.64523C10.3903 1.51837 10.1645 1.4594 9.89678 1.46488C8.13535 1.51563 6.59907 4.2674 6.20711 6.101L7.8944 5.57848L8.19576 5.48523C8.41679 4.32088 8.97145 3.11266 9.69703 2.33506C9.95072 2.05642 10.2502 1.82312 10.5825 1.64523H10.5832ZM9.02979 5.22671L11.4516 4.47654C11.4591 3.84568 11.3905 2.91311 11.0747 2.25483C10.7384 2.39334 10.4556 2.63608 10.2524 2.85346C9.70801 3.43837 9.26388 4.33048 9.03048 5.22671H9.02979ZM12.2101 4.24203L13.3359 3.893C13.1561 3.30877 12.7291 2.32957 11.8635 2.165C12.1326 2.85963 12.2019 3.66397 12.2101 4.24203Z"
          fill="#95BF47"
        />
        <path
          d="M18.5841 5.04545C18.4976 5.03859 16.8213 5.01253 16.8213 5.01253C16.8213 5.01253 15.4189 3.65071 15.2802 3.51151C15.2265 3.46201 15.1585 3.4308 15.0859 3.42236V24.2612L21.3704 22.6985C21.3704 22.6985 18.8058 5.35608 18.7893 5.23745C18.7814 5.18707 18.7568 5.14079 18.7195 5.106C18.6822 5.0712 18.635 5.04988 18.5841 5.04545Z"
          fill="#5E8E3E"
        />
        <path
          d="M11.6035 8.28156L10.8731 11.0135C10.8731 11.0135 10.059 10.6425 9.09317 10.7035C7.67771 10.7927 7.66261 11.6861 7.67702 11.9104C7.7539 13.1309 10.9672 13.3984 11.1477 16.2599C11.2898 18.5111 9.95398 20.0519 8.02917 20.1725C5.71926 20.3186 4.44727 18.9554 4.44727 18.9554L4.93671 16.8722C4.93671 16.8722 6.21694 17.8384 7.24112 17.7732C7.9111 17.7314 8.14999 17.1869 8.12596 16.8016C8.02505 15.2087 5.4083 15.3019 5.24286 12.6838C5.1042 10.4793 6.55055 8.24728 9.74324 8.04568C10.9734 7.96751 11.6035 8.28225 11.6035 8.28225"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_22_2890">
          <rect
            width="21.28"
            height="24"
            fill="white"
            transform="translate(0.360352 0.503906)"
          />
        </clipPath>
      </defs>
    </SvgLogo>
  );
};

const SlackLogo = (props: LogoComponentProps) => {
  return (
    <SvgLogo {...props}>
      <path
        d="M5.04235 15.1662C5.04235 16.5538 3.9088 17.6874 2.52117 17.6874C1.13355 17.6874 0 16.5538 0 15.1662C0 13.7786 1.13355 12.645 2.52117 12.645H5.04235V15.1662Z"
        fill="#E01E5A"
      />
      <path
        d="M6.3125 15.1662C6.3125 13.7786 7.44605 12.645 8.83367 12.645C10.2213 12.645 11.3548 13.7786 11.3548 15.1662V21.4789C11.3548 22.8665 10.2213 24.0001 8.83367 24.0001C7.44605 24.0001 6.3125 22.8665 6.3125 21.4789V15.1662Z"
        fill="#E01E5A"
      />
      <path
        d="M8.83367 5.04235C7.44605 5.04235 6.3125 3.9088 6.3125 2.52117C6.3125 1.13355 7.44605 0 8.83367 0C10.2213 0 11.3548 1.13355 11.3548 2.52117V5.04235H8.83367Z"
        fill="#36C5F0"
      />
      <path
        d="M8.83388 6.3125C10.2215 6.3125 11.3551 7.44605 11.3551 8.83367C11.3551 10.2213 10.2215 11.3548 8.83388 11.3548H2.52117C1.13355 11.3548 0 10.2213 0 8.83367C0 7.44605 1.13355 6.3125 2.52117 6.3125H8.83388Z"
        fill="#36C5F0"
      />
      <path
        d="M18.957 8.83367C18.957 7.44605 20.0906 6.3125 21.4782 6.3125C22.8658 6.3125 23.9994 7.44605 23.9994 8.83367C23.9994 10.2213 22.8658 11.3548 21.4782 11.3548H18.957V8.83367Z"
        fill="#2EB67D"
      />
      <path
        d="M17.6869 8.83388C17.6869 10.2215 16.5533 11.3551 15.1657 11.3551C13.7781 11.3551 12.6445 10.2215 12.6445 8.83388V2.52117C12.6445 1.13355 13.7781 0 15.1657 0C16.5533 0 17.6869 1.13355 17.6869 2.52117V8.83388Z"
        fill="#2EB67D"
      />
      <path
        d="M15.1657 18.958C16.5533 18.958 17.6869 20.0916 17.6869 21.4792C17.6869 22.8668 16.5533 24.0004 15.1657 24.0004C13.7781 24.0004 12.6445 22.8668 12.6445 21.4792V18.958H15.1657Z"
        fill="#ECB22E"
      />
      <path
        d="M15.1657 17.6874C13.7781 17.6874 12.6445 16.5538 12.6445 15.1662C12.6445 13.7786 13.7781 12.645 15.1657 12.645H21.4784C22.866 12.645 23.9996 13.7786 23.9996 15.1662C23.9996 16.5538 22.866 17.6874 21.4784 17.6874H15.1657Z"
        fill="#ECB22E"
      />
    </SvgLogo>
  );
};

const ClayLogo = ({ size = 24 }: LogoComponentProps) => {
  return (
    <img
      src={typeof ClayImage === "string" ? ClayImage : ClayImage.src}
      alt="Clay"
      width={size}
      height={size}
      style={{ objectFit: "contain" }}
    />
  );
};

const AppoloLogo = (props: LogoComponentProps) => {
  return (
    <SvgLogo {...props}>
      <path
        d="M22.2306 16.035L19.9622 12.1784L12.7032 0.200195L0 21.2528H6.80529C7.71267 21.2528 8.62004 21.026 9.3913 20.5722C10.1626 20.1185 10.8431 19.5287 11.2968 18.7574L14.7902 12.9497L12.8393 9.72833L8.62004 16.761C8.39319 17.1693 8.03024 17.4869 7.62193 17.7138C7.21361 17.9407 6.75992 18.0768 6.30624 18.0768H5.80718L12.7032 6.59765L21.5047 21.2075H24V18.8935L22.2306 16.035Z"
        fill="black"
      />
    </SvgLogo>
  );
};

const AttioLogo = (props: LogoComponentProps) => {
  return (
    <SvgLogo {...props}>
      <path
        d="M23.7633 14.092L21.7535 10.9051L21.5564 10.6297C21.2412 10.1575 20.7289 9.88212 20.1771 9.88212L16.9456 9.84277L16.7486 10.2362L12.8865 16.4133L12.6895 16.7674L14.3052 19.3641C14.6205 19.8362 15.1328 20.1116 15.6845 20.1116H20.2165C20.7683 20.1116 21.32 19.8362 21.5959 19.3641L21.7535 19.128L23.7633 15.9018C24.0786 15.3116 24.0786 14.6428 23.7633 14.092ZM23.1328 15.469L21.1229 18.6952C21.1229 18.6952 21.1229 18.7346 21.0835 18.7346C21.0047 18.8133 20.9259 18.8133 20.8865 18.8133C20.8471 18.8133 20.7289 18.8133 20.65 18.6952L18.6402 15.469C18.6008 15.4297 18.6008 15.3903 18.5614 15.351C18.5614 15.3116 18.522 15.2723 18.522 15.2329C18.4826 15.0756 18.4826 14.9182 18.522 14.7215C18.5614 14.6428 18.5614 14.5641 18.6402 14.4854L20.65 11.2985C20.6895 11.2198 20.7683 11.1805 20.8077 11.1805C20.8471 11.1805 20.8471 11.1805 20.8471 11.1805C20.8471 11.1805 20.8471 11.1805 20.8865 11.1805C20.9259 11.1805 21.0441 11.1805 21.1229 11.2985L23.1328 14.4854C23.3298 14.8002 23.3298 15.1542 23.1328 15.469Z"
        fill="black"
      />
      <path
        d="M17.8128 6.34089C18.1281 5.82941 18.1281 5.12121 17.8128 4.60974L15.803 1.42285L15.6453 1.14744C15.33 0.675312 14.8177 0.399902 14.266 0.399902H9.73399C9.18227 0.399902 8.66995 0.675312 8.35468 1.14744L0.236453 14.1311C0.0788177 14.3671 0 14.6819 0 14.9573C0 15.272 0.0788177 15.5474 0.236453 15.8229L2.40394 19.2852C2.71921 19.7966 3.23153 20.072 3.82266 20.072H8.35468C8.9064 20.072 9.45813 19.7966 9.73399 19.3245L9.89162 19.0491L11.5074 16.4524L16.2759 8.81958L17.8128 6.34089ZM17.3399 5.51466C17.3399 5.67203 17.3005 5.82941 17.1823 5.98679L9.26108 18.6556C9.18227 18.7737 9.06404 18.7737 9.02463 18.7737C8.98522 18.7737 8.86699 18.7737 8.78818 18.6556L6.77832 15.4294C6.58128 15.154 6.58128 14.7606 6.77832 14.4851L14.7389 1.8163C14.8177 1.69826 14.936 1.69826 14.9754 1.69826C15.0148 1.69826 15.133 1.69826 15.2118 1.8163L17.2217 5.00318C17.3005 5.16056 17.3399 5.31794 17.3399 5.51466Z"
        fill="black"
      />
    </SvgLogo>
  );
};

const HubspotLogo = (props: LogoComponentProps) => {
  return (
    <SvgLogo {...props}>
      <g clip-path="url(#clip0_22_2896)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M16.8122 17.2947C15.0195 17.2947 13.5664 15.8566 13.5664 14.0829C13.5664 12.3088 15.0195 10.8707 16.8122 10.8707C18.6049 10.8707 20.058 12.3088 20.058 14.0829C20.058 15.8566 18.6049 17.2947 16.8122 17.2947ZM17.7839 7.89901V5.04163C18.5376 4.68936 19.0655 3.93487 19.0655 3.05925V2.9933C19.0655 1.78482 18.0664 0.796098 16.8452 0.796098H16.7789C15.5577 0.796098 14.5586 1.78482 14.5586 2.9933V3.05925C14.5586 3.93487 15.0865 4.68966 15.8402 5.04194V7.89901C14.7181 8.07068 13.6928 8.52868 12.8472 9.20272L4.91952 3.09994C4.97184 2.90114 5.00859 2.6965 5.0089 2.48137C5.01015 1.11293 3.89083 0.00185084 2.50741 1.60552e-06C1.12461 -0.00153942 0.00155883 1.10646 1.62283e-06 2.4752C-0.00155558 3.84395 1.11776 4.95503 2.50118 4.95657C2.95184 4.95719 3.36917 4.83051 3.7348 4.62463L11.533 10.6282C10.8699 11.6188 10.4812 12.8053 10.4812 14.0829C10.4812 15.4202 10.9082 16.6573 11.6295 17.6747L9.2582 20.0217C9.07071 19.9659 8.87638 19.9271 8.6702 19.9271C7.53375 19.9271 6.6122 20.8387 6.6122 21.9634C6.6122 23.0883 7.53375 24 8.6702 24C9.80696 24 10.7282 23.0883 10.7282 21.9634C10.7282 21.76 10.689 21.5673 10.6326 21.3818L12.9784 19.0604C14.0432 19.8645 15.3693 20.3478 16.8122 20.3478C20.3087 20.3478 23.1429 17.5428 23.1429 14.0829C23.1429 10.9506 20.8176 8.36286 17.7839 7.89901Z"
          fill="#FF7A59"
        />
      </g>
      <defs>
        <clipPath id="clip0_22_2896">
          <rect width="23.1429" height="24" fill="white" />
        </clipPath>
      </defs>
    </SvgLogo>
  );
};

const SalesforceLogo = (props: LogoComponentProps) => {
  return (
    <SvgLogo {...props}>
      <mask
        id="mask0_108_21949"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="18"
      >
        <path d="M0 0.600098H24V17.3972H0V0.600098Z" fill="white" />
      </mask>
      <g mask="url(#mask0_108_21949)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.98465 2.43266C10.7588 1.62615 11.8367 1.12569 13.0288 1.12569C14.6133 1.12569 15.9959 2.00929 16.732 3.3212C17.3906 3.02693 18.1039 2.87525 18.8253 2.87614C21.6834 2.87614 24.0004 5.21339 24.0004 8.0967C24.0004 10.98 21.6834 13.3174 18.8253 13.3174C18.4763 13.3174 18.1354 13.2822 17.8057 13.2157C17.1576 14.372 15.9219 15.1534 14.5039 15.1534C13.9304 15.1541 13.3643 15.0239 12.8488 14.7724C12.1917 16.3185 10.6602 17.4025 8.87578 17.4025C7.01711 17.4025 5.43301 16.2266 4.82539 14.5774C4.55457 14.6345 4.27854 14.6633 4.00176 14.6631C1.78887 14.6631 -0.00488281 12.8506 -0.00488281 10.6148C-0.00488281 9.11622 0.800927 7.80793 1.99862 7.10805C1.74486 6.52374 1.61428 5.89338 1.61503 5.25635C1.61503 2.68483 3.70249 0.600098 6.27745 0.600098C7.78923 0.600098 9.1328 1.31876 9.98465 2.43266Z"
          fill="#00A1E0"
        />
      </g>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.47225 9.31349C3.45717 9.35283 3.47763 9.36103 3.48248 9.368C3.52755 9.40063 3.57333 9.42427 3.61955 9.45082C3.86431 9.58039 4.09566 9.6184 4.33733 9.6184C4.82976 9.6184 5.13565 9.35662 5.13565 8.93502V8.92673C5.13565 8.53688 4.79034 8.39522 4.46672 8.293L4.42448 8.27933C4.18042 8.20012 3.9698 8.13159 3.9698 7.9708V7.96259C3.9698 7.82491 4.09293 7.72374 4.28371 7.72374C4.49583 7.72374 4.74721 7.79422 4.90932 7.88374C4.90932 7.88374 4.95713 7.91461 4.9745 7.86848C4.98394 7.84352 5.06588 7.62284 5.07461 7.59894C5.08396 7.5731 5.06755 7.5536 5.05071 7.54355C4.86557 7.43074 4.60988 7.354 4.34518 7.354L4.29605 7.35418C3.84534 7.35418 3.53064 7.62672 3.53064 8.01675V8.02513C3.53064 8.43615 3.8778 8.56977 4.203 8.66265L4.25522 8.67888C4.49204 8.75156 4.69658 8.81436 4.69658 8.98097V8.98926C4.69658 9.14185 4.56366 9.25519 4.34959 9.25519C4.2666 9.25519 4.00164 9.25378 3.71534 9.0727C3.68067 9.0525 3.66092 9.03795 3.63419 9.02163C3.62008 9.01308 3.5848 8.99764 3.56945 9.04386L3.47225 9.31349ZM10.681 9.31349C10.6659 9.35283 10.6863 9.36103 10.6914 9.368C10.7363 9.40063 10.7821 9.42427 10.8283 9.45082C11.0731 9.58039 11.3045 9.6184 11.546 9.6184C12.0385 9.6184 12.3444 9.35662 12.3444 8.93502V8.92673C12.3444 8.53688 11.9992 8.39522 11.6755 8.293L11.6333 8.27933C11.3892 8.20012 11.1785 8.13159 11.1785 7.9708V7.96259C11.1785 7.82491 11.3017 7.72374 11.4926 7.72374C11.7046 7.72374 11.9559 7.79422 12.118 7.88374C12.118 7.88374 12.1658 7.91461 12.1833 7.86848C12.1927 7.84352 12.2747 7.62284 12.2833 7.59894C12.2928 7.5731 12.2763 7.5536 12.2595 7.54355C12.0743 7.43074 11.8187 7.354 11.554 7.354L11.5048 7.35418C11.0541 7.35418 10.7394 7.62672 10.7394 8.01675V8.02513C10.7394 8.43615 11.0865 8.56977 11.4118 8.66265L11.4639 8.67888C11.7008 8.75156 11.9054 8.81436 11.9054 8.98097V8.98926C11.9054 9.14185 11.7724 9.25519 11.5585 9.25519C11.4753 9.25519 11.2104 9.25378 10.9241 9.0727C10.8895 9.0525 10.8692 9.03857 10.8429 9.02163C10.834 9.01599 10.7925 8.99976 10.7783 9.04386L10.681 9.31349ZM15.6022 8.48757C15.6022 8.72572 15.5577 8.91376 15.4704 9.04633C15.3836 9.17775 15.2526 9.24169 15.07 9.24169C14.8873 9.24169 14.757 9.17784 14.6716 9.0465C14.5855 8.91385 14.5417 8.72572 14.5417 8.48757C14.5417 8.2496 14.5855 8.06217 14.6716 7.93093C14.757 7.80083 14.8873 7.73768 15.07 7.73768C15.2526 7.73768 15.3836 7.80092 15.4704 7.93102C15.5579 8.06217 15.6022 8.2496 15.6022 8.48757ZM16.0134 8.04595C15.9729 7.90932 15.91 7.7891 15.8263 7.68882C15.7424 7.58827 15.6363 7.50739 15.5105 7.44882C15.3849 7.39017 15.2368 7.36044 15.07 7.36044C14.9032 7.36044 14.7549 7.39017 14.6292 7.44882C14.5036 7.50739 14.3974 7.58827 14.3135 7.68899C14.2299 7.78946 14.1669 7.9095 14.1266 8.04595C14.0864 8.18151 14.0661 8.33013 14.0661 8.48757C14.0661 8.6451 14.0864 8.79381 14.1266 8.9292C14.1669 9.06556 14.2298 9.18569 14.3136 9.28632C14.3975 9.38705 14.504 9.46723 14.6294 9.52438C14.7552 9.58153 14.9034 9.61064 15.07 9.61064C15.2367 9.61064 15.3847 9.58153 15.5104 9.52438C15.636 9.46723 15.7422 9.38705 15.8263 9.28632C15.91 9.18604 15.9729 9.06573 16.0134 8.9292C16.0534 8.79354 16.0738 8.64492 16.0738 8.48757C16.0738 8.33031 16.0534 8.1816 16.0134 8.04595ZM19.3886 9.17792C19.3751 9.13797 19.3361 9.15305 19.3361 9.15305C19.2764 9.1759 19.2129 9.19706 19.145 9.20765C19.0765 9.21841 19.0008 9.22379 18.9197 9.22379C18.721 9.22379 18.5627 9.16461 18.4497 9.04765C18.3362 8.93061 18.2724 8.7415 18.2731 8.48572C18.2737 8.25322 18.33 8.07805 18.4309 7.94451C18.5309 7.81186 18.6837 7.74377 18.8868 7.74377C19.0564 7.74377 19.1858 7.76344 19.3214 7.80595C19.3214 7.80595 19.3536 7.81997 19.369 7.77755C19.4051 7.67762 19.4317 7.60653 19.4702 7.49671C19.4811 7.4654 19.4543 7.45217 19.4445 7.44838C19.3912 7.42756 19.2654 7.39343 19.1704 7.37905C19.0815 7.36547 18.9777 7.35841 18.8619 7.35841C18.6893 7.35841 18.5354 7.38796 18.4038 7.44653C18.2725 7.50501 18.1611 7.5858 18.0728 7.68626C17.9845 7.7869 17.9173 7.90712 17.8728 8.04348C17.8283 8.17913 17.8058 8.32801 17.8058 8.48589C17.8058 8.82679 17.8978 9.10225 18.0792 9.30405C18.2613 9.50656 18.5343 9.60941 18.8908 9.60941C19.1013 9.60941 19.3173 9.56681 19.4729 9.50559C19.4729 9.50559 19.5025 9.4913 19.4897 9.45673L19.3886 9.17792ZM20.1078 8.25922C20.1274 8.12683 20.1637 8.01684 20.2202 7.93093C20.3055 7.80083 20.4354 7.72913 20.618 7.72913C20.8008 7.72913 20.9212 7.80092 21.008 7.93102C21.0653 8.01702 21.0903 8.13159 21.1001 8.25939L20.1078 8.25922ZM21.4916 7.96842C21.4566 7.83664 21.3703 7.70355 21.3136 7.64269C21.2241 7.5462 21.1364 7.47863 21.0493 7.44132C20.9233 7.38778 20.7878 7.36027 20.6509 7.36044C20.4772 7.36044 20.3195 7.38981 20.1915 7.44979C20.0633 7.50994 19.9556 7.59215 19.8712 7.69429C19.7866 7.79633 19.7232 7.91779 19.6827 8.05556C19.6422 8.19254 19.6217 8.34186 19.6217 8.49957C19.6217 8.65992 19.643 8.80942 19.6848 8.94384C19.727 9.0794 19.7948 9.19839 19.8864 9.29744C19.9779 9.39684 20.0956 9.47481 20.2363 9.52914C20.3763 9.58339 20.5463 9.61152 20.7413 9.61091C21.1433 9.60958 21.3548 9.51997 21.4421 9.47172C21.4575 9.46308 21.4721 9.44817 21.4539 9.40522L21.3629 9.15049C21.3489 9.11248 21.3105 9.12624 21.3105 9.12624C21.2107 9.16346 21.0695 9.22988 20.7393 9.22917C20.5236 9.22882 20.3637 9.16505 20.2633 9.06547C20.1605 8.96359 20.1101 8.814 20.1015 8.60267L21.4926 8.60373C21.4926 8.60373 21.5293 8.60338 21.5331 8.56757C21.5346 8.55275 21.5808 8.2818 21.4916 7.96842ZM8.96448 8.25922C8.98414 8.12683 9.02048 8.01684 9.07693 7.93093C9.16231 7.80083 9.29197 7.72913 9.47481 7.72913C9.65756 7.72913 9.77796 7.80092 9.86475 7.93102C9.92199 8.01702 9.94704 8.13159 9.95683 8.25939L8.96448 8.25922ZM10.3483 7.96842C10.3133 7.83664 10.227 7.70355 10.1704 7.64269C10.0808 7.5462 9.99326 7.47863 9.90612 7.44132C9.78012 7.38781 9.6446 7.36029 9.50771 7.36044C9.33404 7.36044 9.17625 7.38981 9.04827 7.44979C8.92011 7.50994 8.81242 7.59215 8.72783 7.69429C8.64342 7.79633 8.58001 7.91779 8.53934 8.05556C8.49886 8.19254 8.47849 8.34186 8.47849 8.49957C8.47849 8.65992 8.49956 8.80942 8.54164 8.94384C8.5838 9.0794 8.65171 9.19839 8.74309 9.29744C8.83464 9.39684 8.9523 9.47481 9.09299 9.52914C9.23305 9.58339 9.40293 9.61152 9.59812 9.61091C10.0001 9.60958 10.2116 9.51997 10.2989 9.47172C10.3142 9.46308 10.3289 9.44817 10.3106 9.40522L10.2197 9.15049C10.2056 9.11248 10.1672 9.12624 10.1672 9.12624C10.0675 9.16346 9.92631 9.22988 9.596 9.22917C9.38035 9.22882 9.22044 9.16505 9.11997 9.06547C9.01731 8.96359 8.96677 8.814 8.95821 8.60267L10.3494 8.60373C10.3494 8.60373 10.3861 8.60338 10.3899 8.56757C10.3914 8.55275 10.4376 8.2818 10.3483 7.96842ZM5.95707 9.17034C5.90247 9.12677 5.89488 9.1161 5.8768 9.08778C5.8492 9.04518 5.83508 8.9845 5.83508 8.90679C5.83508 8.78463 5.87566 8.69661 5.95927 8.63751C5.95839 8.63769 6.07923 8.53326 6.36279 8.53696C6.4893 8.53921 6.6155 8.54997 6.74056 8.56916V9.20156H6.74074C6.74074 9.20156 6.56389 9.23958 6.36482 9.25157C6.08187 9.2686 5.95618 9.17007 5.95707 9.17034ZM6.51071 8.19254C6.45426 8.18839 6.38114 8.18636 6.29347 8.18636C6.17431 8.18636 6.05903 8.20118 5.9508 8.23029C5.84214 8.25957 5.74441 8.30491 5.66036 8.36497C5.57635 8.42498 5.50727 8.5035 5.45846 8.59447C5.40916 8.68629 5.38402 8.79416 5.38402 8.91508C5.38402 9.03848 5.40545 9.14538 5.44779 9.2327C5.48921 9.31927 5.55157 9.39415 5.62922 9.45056C5.70657 9.50683 5.80201 9.54811 5.9127 9.57333C6.02198 9.59829 6.14582 9.61091 6.28112 9.61091C6.42401 9.61091 6.5661 9.59891 6.70378 9.57571C6.82106 9.55551 6.93789 9.5328 7.05421 9.50762C7.1006 9.49695 7.15176 9.48293 7.15176 9.48293C7.18616 9.47419 7.18351 9.43741 7.18351 9.43741L7.18272 8.16502C7.18272 7.88595 7.10827 7.6792 6.96159 7.55078C6.81562 7.42298 6.60067 7.35841 6.32257 7.35841C6.21814 7.35841 6.05038 7.37253 5.94966 7.39272C5.94966 7.39272 5.64589 7.45164 5.52082 7.54964C5.52082 7.54964 5.4933 7.56657 5.5083 7.60494L5.60682 7.86954C5.61908 7.90385 5.65251 7.89212 5.65251 7.89212C5.65251 7.89212 5.663 7.88798 5.67535 7.88066C5.94295 7.73512 6.28156 7.73945 6.28156 7.73945C6.43186 7.73945 6.54766 7.76987 6.62546 7.82941C6.7014 7.88771 6.73994 7.97547 6.73994 8.16096V8.21979C6.62061 8.2025 6.51071 8.19254 6.51071 8.19254ZM17.733 7.47572C17.735 7.47107 17.7361 7.46606 17.7361 7.461C17.7361 7.45593 17.7352 7.45091 17.7332 7.44624C17.7313 7.44157 17.7284 7.43733 17.7248 7.43379C17.7211 7.43025 17.7168 7.42747 17.7121 7.42562C17.6884 7.41663 17.5701 7.39167 17.4789 7.38602C17.304 7.37508 17.2071 7.40454 17.1201 7.4437C17.0339 7.4826 16.9383 7.54549 16.8851 7.6172L16.8849 7.4475C16.8849 7.42421 16.8684 7.40543 16.8449 7.40543H16.4882C16.4651 7.40543 16.4484 7.42421 16.4484 7.4475V9.52306C16.4484 9.53426 16.4529 9.54499 16.4608 9.55291C16.4687 9.56082 16.4794 9.56528 16.4906 9.56531H16.8562C16.8674 9.56528 16.8781 9.56082 16.886 9.5529C16.8939 9.54498 16.8984 9.53425 16.8984 9.52306V8.48625C16.8984 8.34698 16.9137 8.20824 16.9443 8.121C16.9745 8.03466 17.0155 7.96586 17.0663 7.91638C17.1145 7.86862 17.1734 7.83316 17.2381 7.81301C17.2988 7.79559 17.3616 7.78674 17.4248 7.78672C17.4975 7.78672 17.5776 7.80542 17.5776 7.80542C17.6044 7.80842 17.6193 7.79201 17.6284 7.76785C17.6523 7.70425 17.7201 7.51365 17.733 7.47572Z"
        fill="#FFFFFE"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.3014 6.51414C14.2563 6.5005 14.2104 6.4896 14.1639 6.4815C14.1014 6.47107 14.0381 6.46617 13.9748 6.46686C13.7232 6.46686 13.5248 6.53795 13.3855 6.67837C13.2472 6.81773 13.1531 7.03003 13.1059 7.30936L13.0889 7.40365H12.773C12.773 7.40365 12.7345 7.40206 12.7264 7.44413L12.6745 7.73343C12.6709 7.76113 12.6828 7.77842 12.7199 7.77824H13.0273L12.7154 9.5196C12.6909 9.65985 12.663 9.77521 12.632 9.86262C12.6015 9.94888 12.5717 10.0135 12.535 10.0605C12.4994 10.1059 12.4658 10.1393 12.4076 10.1588C12.3596 10.1749 12.3044 10.1824 12.2439 10.1824C12.2102 10.1824 12.1654 10.1767 12.1324 10.1701C12.0993 10.1636 12.0821 10.1562 12.0573 10.1457C12.0573 10.1457 12.0212 10.132 12.007 10.1682C11.9955 10.1977 11.9135 10.4231 11.9038 10.4509C11.8939 10.4784 11.9078 10.5001 11.9253 10.5064C11.9662 10.521 11.9966 10.5304 12.0524 10.5435C12.1298 10.5618 12.1951 10.5629 12.2562 10.5629C12.3843 10.5629 12.5009 10.5449 12.5977 10.51C12.6951 10.4748 12.7798 10.4135 12.8548 10.3305C12.9359 10.241 12.9869 10.1472 13.0356 10.0194C13.0839 9.89261 13.125 9.73526 13.1579 9.55189L13.4713 7.77824H13.9296C13.9296 7.77824 13.9683 7.77965 13.9763 7.73776L14.0282 7.44846C14.0318 7.42076 14.02 7.40347 13.9827 7.40365H13.5379C13.5401 7.39359 13.5603 7.23712 13.6114 7.08983C13.6332 7.02694 13.6742 6.97622 13.709 6.94138C13.7414 6.9082 13.7814 6.88333 13.8255 6.86888C13.8738 6.85394 13.9242 6.84667 13.9748 6.84736C14.0167 6.84736 14.0578 6.85239 14.0891 6.85892C14.1322 6.86809 14.149 6.87294 14.1603 6.87629C14.2056 6.89014 14.2117 6.87673 14.2206 6.85477L14.327 6.56265C14.3379 6.53125 14.3113 6.51802 14.3014 6.51414ZM8.08549 9.52331C8.08549 9.54659 8.06891 9.56556 8.04562 9.56556H7.67667C7.6533 9.56556 7.63672 9.54659 7.63672 9.52331V6.55374C7.63672 6.53054 7.6533 6.51176 7.67667 6.51176H8.04562C8.06891 6.51176 8.08549 6.53054 8.08549 6.55374V9.52331Z"
        fill="#FFFFFE"
      />
    </SvgLogo>
  );
};

const CalendlyLogo = (props: LogoComponentProps) => {
  return (
    <SvgLogo {...props}>
      <g clip-path="url(#clip0_108_22018)">
        <path
          d="M16.4349 15.8366C15.6583 16.5243 14.6945 17.3804 12.9355 17.3804H11.8828C10.6103 17.3804 9.45477 16.9173 8.6267 16.0798C7.81734 15.2611 7.37295 14.143 7.37295 12.9266V11.4904C7.37295 10.274 7.81734 9.15586 8.6267 8.33715C9.45477 7.49972 10.6103 7.03656 11.8828 7.03656H12.9308C14.6899 7.03656 15.6536 7.8927 16.4303 8.58042C17.2349 9.29153 17.932 9.90908 19.7799 9.90908C20.07 9.90908 20.3507 9.88568 20.622 9.84358C20.622 9.8389 20.6174 9.83422 20.6174 9.82954C20.5051 9.5582 20.3787 9.28685 20.229 9.02954L18.9893 6.88685C17.8524 4.91726 15.7519 3.70557 13.4829 3.70557H11.008C8.7343 3.70557 6.63376 4.91726 5.5016 6.88685L4.26181 9.02954C3.12497 10.9991 3.12497 13.4225 4.26181 15.3921L5.5016 17.5348C6.63844 19.5044 8.73898 20.7161 11.008 20.7161H13.4829C15.7566 20.7161 17.8571 19.5044 18.9893 17.5348L20.229 15.3921C20.3787 15.1348 20.5098 14.8635 20.6174 14.5921C20.6174 14.5874 20.622 14.5828 20.622 14.5781C20.346 14.536 20.0653 14.5126 19.7799 14.5126C17.932 14.5079 17.2396 15.1208 16.4349 15.8366Z"
          fill="#231F20"
        />
        <path
          d="M12.936 8.3418H11.8834C9.95123 8.3418 8.67871 9.72191 8.67871 11.4903V12.9266C8.67871 14.695 9.95123 16.0751 11.8834 16.0751H12.9313C15.7477 16.0751 15.5278 13.2026 19.7851 13.2026C20.1921 13.2026 20.5945 13.24 20.9875 13.3149C21.1185 12.5851 21.1185 11.8365 20.9875 11.1067C20.5945 11.1816 20.1921 11.219 19.7851 11.219C15.5325 11.2143 15.7524 8.3418 12.936 8.3418Z"
          fill="#231F20"
        />
        <path
          d="M23.4341 14.3673C22.7089 13.8292 21.8716 13.483 20.9874 13.3146C20.9874 13.324 20.9874 13.3287 20.9827 13.338C20.9078 13.7591 20.7908 14.1754 20.6271 14.5778C21.3709 14.6994 22.0587 14.9801 22.6482 15.4105C22.6482 15.4152 22.6435 15.4246 22.6435 15.4292C22.3066 16.5287 21.792 17.5673 21.1277 18.5123C20.4681 19.4433 19.668 20.2667 18.7557 20.9497C16.8563 22.3719 14.5967 23.1251 12.2154 23.1251C10.7417 23.1251 9.3148 22.8351 7.96743 22.269C6.66684 21.7216 5.50198 20.931 4.50079 19.9298C3.49962 18.9287 2.71366 17.7591 2.16161 16.4632C1.59085 15.1205 1.30546 13.6889 1.30546 12.2152C1.30546 10.7415 1.59553 9.31462 2.16161 7.96725C2.70898 6.66667 3.49962 5.50175 4.50079 4.50058C5.50198 3.49941 6.67152 2.71345 7.96743 2.1614C9.31012 1.59064 10.7417 1.30526 12.2154 1.30526C14.5967 1.30526 16.8563 2.05848 18.7557 3.4807C19.668 4.16842 20.4681 4.98713 21.1277 5.91813C21.7967 6.86316 22.3066 7.89708 22.6435 9.00117C22.6435 9.00585 22.6482 9.0152 22.6482 9.01988C22.0587 9.45029 21.3709 9.73099 20.6271 9.85263C20.7861 10.255 20.9078 10.6713 20.9827 11.0924C20.9827 11.0971 20.9827 11.1064 20.9874 11.1111C21.8716 10.9474 22.7043 10.5965 23.4341 10.0585C24.1312 9.54386 23.9955 8.95906 23.8879 8.61287C22.3534 3.62573 17.7078 0 12.2154 0C5.46923 0 0.00488281 5.46901 0.00488281 12.2105C0.00488281 18.952 5.47391 24.4211 12.2154 24.4211C17.7078 24.4211 22.3534 20.7953 23.8879 15.8082C23.9955 15.462 24.1312 14.8819 23.4341 14.3673Z"
          fill="#231F20"
        />
      </g>
      <defs>
        <clipPath id="clip0_108_22018">
          <rect width="24" height="24.4211" fill="white" />
        </clipPath>
      </defs>
    </SvgLogo>
  );
};

const WhatsappLogo = (props: LogoComponentProps) => {
  return (
    <SvgLogo {...props}>
      <path
        d="M0 24L2.064 17.8084C1.01669 16.0469 0.413793 13.9912 0.413793 11.7931C0.413793 5.28 5.69379 0 12.2069 0C18.72 0 24 5.28 24 11.7931C24 18.3062 18.72 23.5862 12.2069 23.5862C10.2252 23.5862 8.35903 23.095 6.72 22.2319L0 24Z"
        fill="#2CB742"
      />
      <path
        d="M19.7311 15.7181C19.1866 14.689 17.1784 13.5121 17.1784 13.5121C16.7241 13.2531 16.1758 13.2241 15.9168 13.6859C15.9168 13.6859 15.2642 14.4684 15.0983 14.581C14.3402 15.0945 13.638 15.0746 12.9292 14.3658L11.2819 12.7185L9.63459 11.0712C8.92576 10.3623 8.9059 9.66014 9.41941 8.90207C9.53197 8.73614 10.3144 8.08358 10.3144 8.08358C10.7762 7.82414 10.7473 7.27627 10.4882 6.82193C10.4882 6.82193 9.31141 4.81379 8.28231 4.26924C7.84452 4.03752 7.307 4.11862 6.95693 4.46869L6.22948 5.19614C3.92176 7.50386 5.05804 10.1091 7.36576 12.4168L9.47486 14.5259L11.584 16.635C13.8917 18.9428 16.4969 20.079 18.8047 17.7713L19.5321 17.0439C19.8822 16.693 19.9629 16.1554 19.7311 15.7181Z"
        fill="white"
      />
    </SvgLogo>
  );
};

const InstagramLogo = ({ size = 24 }: LogoComponentProps) => {
  return (
    <img
      src={
        typeof InstagramImage === "string" ? InstagramImage : InstagramImage.src
      }
      alt="Instagram"
      width={size}
      height={size}
      style={{ objectFit: "contain" }}
    />
  );
};

const iMessageLogo = (props: LogoComponentProps) => {
  return (
    <SvgLogo {...props}>
      <path
        d="M18.7143 0H5.28571C2.3665 0 0 2.3665 0 5.28572V18.7143C0 21.6335 2.3665 24 5.28571 24H18.7143C21.6335 24 24 21.6335 24 18.7143V5.28572C24 2.3665 21.6335 0 18.7143 0Z"
        fill="url(#paint0_linear_128_17207)"
      />
      <path
        d="M12.0003 4.15479C9.66407 4.1548 7.42349 4.92783 5.7715 6.30383C4.11951 7.67983 3.19142 9.54608 3.19141 11.492C3.19354 12.7578 3.58875 14.0015 4.33863 15.1024C5.08851 16.2033 6.16756 17.1239 7.47091 17.7748C7.12378 18.5519 6.60315 19.2807 5.93059 19.9308C7.23484 19.7019 8.45917 19.2209 9.50828 18.5253C10.3172 18.7256 11.1565 18.8279 12.0003 18.8293C14.3366 18.8293 16.5772 18.0562 18.2292 16.6802C19.8812 15.3042 20.8093 13.438 20.8093 11.492C20.8093 9.54608 19.8812 7.67983 18.2292 6.30383C16.5772 4.92783 14.3366 4.1548 12.0003 4.15479Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_128_17207"
          x1="12.1905"
          y1="22.4069"
          x2="12.1905"
          y2="2.97851"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0CBD2A" />
          <stop offset="1" stop-color="#5BF675" />
        </linearGradient>
      </defs>
    </SvgLogo>
  );
};

const LINELogo = (props: LogoComponentProps) => {
  return (
    <SvgLogo {...props}>
      <path
        d="M18.5895 0H5.4105C2.42236 0 0 2.42236 0 5.4105V18.5895C0 21.5776 2.42236 24 5.4105 24H18.5895C21.5776 24 24 21.5776 24 18.5895V5.4105C24 2.42236 21.5776 0 18.5895 0Z"
        fill="#06C755"
      />
      <path
        d="M19.9996 10.869C19.9996 7.28849 16.4101 4.37549 11.9978 4.37549C7.58559 4.37549 3.99609 7.28849 3.99609 10.869C3.99609 14.079 6.84609 16.7677 10.6876 17.2755C10.9486 17.3317 11.3033 17.4472 11.3926 17.67C11.4736 17.8725 11.4458 18.1897 11.4188 18.3937C11.4188 18.3937 11.3251 18.9585 11.3048 19.0785C11.2696 19.281 11.1436 19.8697 11.9978 19.5105C12.8521 19.1512 16.6058 16.797 18.2843 14.8642C19.4438 13.593 19.9996 12.3 19.9996 10.869Z"
        fill="white"
      />
      <path
        d="M17.3365 12.9368H15.0865C15.0467 12.9368 15.0086 12.921 14.9805 12.8928C14.9523 12.8647 14.9365 12.8265 14.9365 12.7868V9.29551C14.9365 9.25573 14.9523 9.21757 14.9805 9.18944C15.0086 9.16131 15.0467 9.14551 15.0865 9.14551H17.3365C17.3763 9.14551 17.4145 9.16131 17.4426 9.18944C17.4707 9.21757 17.4865 9.25573 17.4865 9.29551V9.86326C17.4865 9.90304 17.4707 9.94119 17.4426 9.96932C17.4145 9.99745 17.3763 10.0133 17.3365 10.0133H15.8088V10.602H17.3365C17.3763 10.602 17.4145 10.6178 17.4426 10.6459C17.4707 10.6741 17.4865 10.7122 17.4865 10.752V11.325C17.4865 11.3648 17.4707 11.4029 17.4426 11.4311C17.4145 11.4592 17.3763 11.475 17.3365 11.475H15.8088V12.0645H17.3365C17.3763 12.0645 17.4145 12.0803 17.4426 12.1084C17.4707 12.1366 17.4865 12.1747 17.4865 12.2145V12.7815C17.4872 12.8016 17.4839 12.8217 17.4766 12.8405C17.4694 12.8593 17.4585 12.8765 17.4445 12.891C17.4305 12.9055 17.4137 12.917 17.3952 12.9249C17.3766 12.9327 17.3567 12.9368 17.3365 12.9368Z"
        fill="#06C755"
      />
      <path
        d="M9.02177 12.9365C9.06156 12.9365 9.09971 12.9207 9.12784 12.8926C9.15597 12.8645 9.17177 12.8263 9.17177 12.7865V12.2195C9.17177 12.1797 9.15597 12.1416 9.12784 12.1135C9.09971 12.0853 9.06156 12.0695 9.02177 12.0695H7.49402V9.29453C7.49402 9.25475 7.47822 9.2166 7.45009 9.18847C7.42196 9.16033 7.38381 9.14453 7.34402 9.14453H6.77402C6.73424 9.14453 6.69609 9.16033 6.66796 9.18847C6.63983 9.2166 6.62402 9.25475 6.62402 9.29453V12.7843C6.62402 12.8241 6.63983 12.8622 6.66796 12.8903C6.69609 12.9185 6.73424 12.9343 6.77402 12.9343H9.02402L9.02177 12.9365Z"
        fill="#06C755"
      />
      <path
        d="M10.3743 9.13867H9.8073C9.7228 9.13867 9.6543 9.20717 9.6543 9.29167V12.7837C9.6543 12.8682 9.7228 12.9367 9.8073 12.9367H10.3743C10.4588 12.9367 10.5273 12.8682 10.5273 12.7837V9.29167C10.5273 9.20717 10.4588 9.13867 10.3743 9.13867Z"
        fill="#06C755"
      />
      <path
        d="M14.2383 9.13867H13.6713C13.6315 9.13867 13.5933 9.15448 13.5652 9.18261C13.5371 9.21074 13.5213 9.24889 13.5213 9.28867V11.3632L11.9238 9.20542C11.9201 9.19971 11.9158 9.19443 11.911 9.18967L11.902 9.18067L11.8938 9.17392H11.8893L11.881 9.16792H11.8765L11.8683 9.16342H11.863H11.8548H11.8495H11.8405H11.8345H11.8255H11.8195H11.8113H11.233C11.1932 9.16342 11.1551 9.17923 11.1269 9.20736C11.0988 9.23549 11.083 9.27364 11.083 9.31342V12.8054C11.083 12.8452 11.0988 12.8834 11.1269 12.9115C11.1551 12.9396 11.1932 12.9554 11.233 12.9554H11.8008C11.8405 12.9554 11.8787 12.9396 11.9068 12.9115C11.935 12.8834 11.9508 12.8452 11.9508 12.8054V10.7107L13.5505 12.8707C13.561 12.886 13.5742 12.8992 13.5895 12.9097L13.5985 12.9157H13.603L13.6105 12.9194H13.618H13.6233H13.6338C13.647 12.9227 13.6606 12.9245 13.6743 12.9247H14.2383C14.278 12.9247 14.3162 12.9089 14.3443 12.8807C14.3725 12.8526 14.3883 12.8145 14.3883 12.7747V9.29167C14.3887 9.27172 14.3851 9.25189 14.3777 9.23335C14.3704 9.2148 14.3594 9.19791 14.3454 9.18366C14.3314 9.16941 14.3148 9.1581 14.2964 9.15037C14.278 9.14264 14.2582 9.13867 14.2383 9.13867Z"
        fill="#06C755"
      />
    </SvgLogo>
  );
};

const FacebookMessengerLogo = (props: LogoComponentProps) => {
  return (
    <SvgLogo {...props}>
      <g clip-path="url(#clip0_128_17249)">
        <path
          d="M12 0C5.241 0 0 4.953 0 11.64C0 15.138 1.434 18.162 3.768 20.25C3.963 20.424 4.083 20.67 4.089 20.934L4.155 23.07C4.15981 23.2272 4.20314 23.3807 4.2812 23.5172C4.35926 23.6537 4.46965 23.769 4.60267 23.8528C4.73569 23.9366 4.88726 23.9865 5.04408 23.9981C5.20089 24.0096 5.35814 23.9825 5.502 23.919L7.884 22.869C8.085 22.779 8.313 22.764 8.526 22.821C9.621 23.121 10.785 23.283 12 23.283C18.759 23.283 24 18.33 24 11.643C24 4.956 18.759 0 12 0Z"
          fill="url(#paint0_radial_128_17249)"
        />
        <path
          d="M4.79413 15.0451L8.31913 9.45309C8.45174 9.24256 8.62655 9.0618 8.83254 8.92223C9.03853 8.78267 9.27121 8.68732 9.5159 8.64222C9.7606 8.59711 10.012 8.60323 10.2542 8.66018C10.4964 8.71713 10.7242 8.82368 10.9231 8.97309L13.7281 11.0761C13.8534 11.1698 14.0057 11.2203 14.1621 11.2197C14.3186 11.2192 14.4706 11.1677 14.5951 11.0731L18.3811 8.19909C18.8851 7.81509 19.5451 8.42109 19.2091 8.95809L15.6811 14.5471C15.5485 14.7576 15.3737 14.9384 15.1677 15.078C14.9617 15.2175 14.7291 15.3129 14.4844 15.358C14.2397 15.4031 13.9883 15.397 13.7461 15.34C13.5039 15.2831 13.2761 15.1765 13.0771 15.0271L10.2721 12.9241C10.1469 12.8303 9.99456 12.7799 9.83813 12.7805C9.6817 12.781 9.52971 12.8325 9.40513 12.9271L5.61913 15.8011C5.11513 16.1851 4.45513 15.5821 4.79413 15.0451Z"
          fill="white"
        />
      </g>
      <defs>
        <radialGradient
          id="paint0_radial_128_17249"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(4.02 24) scale(26.4 26.4)"
        >
          <stop stop-color="#0099FF" />
          <stop offset="0.6" stop-color="#A033FF" />
          <stop offset="0.9" stop-color="#FF5280" />
          <stop offset="1" stop-color="#FF7061" />
        </radialGradient>
        <clipPath id="clip0_128_17249">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </SvgLogo>
  );
};

const GoogleLogo = (props: LogoComponentProps) => {
  return (
    <SvgLogo {...props}>
      <mask
        id="mask0_144_11176"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <path
          d="M23.7695 9.77372H12.2556V14.3873H18.8716C18.7652 15.0403 18.5264 15.6826 18.1767 16.2683C17.776 16.9393 17.2807 17.4502 16.7729 17.8392C15.2521 19.0046 13.479 19.2429 12.2476 19.2429C9.13691 19.2429 6.47903 17.2325 5.45011 14.5006C5.40859 14.4014 5.38102 14.299 5.34745 14.1978C5.12007 13.5025 4.99584 12.7661 4.99584 12.0008C4.99584 11.2042 5.13037 10.4417 5.37566 9.7216C6.34319 6.88141 9.06099 4.76006 12.2498 4.76006C12.8912 4.76006 13.5089 4.83641 14.0946 4.98869C15.4333 5.3367 16.3801 6.02212 16.9603 6.56428L20.4613 3.13576C18.3317 1.18317 15.5555 2.95218e-09 12.244 2.95218e-09C9.59665 -5.69793e-05 7.1525 0.824781 5.1496 2.21878C3.52531 3.34928 2.19316 4.86288 1.29412 6.62075C0.457891 8.25066 0 10.0569 0 11.999C0 13.9411 0.458591 15.7661 1.29483 17.381V17.3918C2.1781 19.1062 3.46975 20.5823 5.0396 21.7076C6.41104 22.6907 8.87017 24 12.244 24C14.1842 24 15.9038 23.6502 17.4203 22.9946C18.5142 22.5217 19.4835 21.9049 20.3611 21.1122C21.5206 20.0647 22.4288 18.7691 23.0486 17.2785C23.6684 15.7878 24 14.1022 24 12.2747C24 11.4236 23.9145 10.5592 23.7695 9.77363V9.77372Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_144_11176)">
        <g filter="url(#filter0_f_144_11176)">
          <path
            d="M-0.177734 12.0806C-0.165008 13.9921 0.379665 15.9642 1.20412 17.5563V17.5673C1.79983 18.7235 2.61399 19.6368 3.5413 20.5417L9.14205 18.4982C8.08242 17.9599 7.92073 17.6301 7.16115 17.0282C6.38493 16.2455 5.8064 15.347 5.44612 14.2934H5.4316L5.44612 14.2824C5.20909 13.5866 5.18571 12.8481 5.17697 12.0806H-0.177734Z"
            fill="url(#paint0_radial_144_11176)"
          />
        </g>
        <g filter="url(#filter1_f_144_11176)">
          <path
            d="M12.2554 -0.0874023C11.7018 1.85739 11.9135 3.74779 12.2554 4.84771C12.8947 4.84819 13.5105 4.92439 14.0944 5.07619C15.433 5.42421 16.3798 6.10964 16.96 6.6518L20.5506 3.13569C18.4235 1.18543 15.8637 -0.0843296 12.2554 -0.0874023Z"
            fill="url(#paint1_radial_144_11176)"
          />
        </g>
        <g filter="url(#filter2_f_144_11176)">
          <path
            d="M12.2427 -0.102539C9.52736 -0.102598 7.02047 0.743416 4.96616 2.17321C4.20339 2.7041 3.50341 3.31735 2.88013 3.99931C2.71684 5.53117 4.10245 7.41398 6.84637 7.3984C8.17771 5.84975 10.1467 4.84778 12.3382 4.84778C12.3402 4.84778 12.3422 4.84795 12.3442 4.84796L12.2547 -0.102189C12.2506 -0.102191 12.2467 -0.102539 12.2427 -0.102539Z"
            fill="url(#paint2_radial_144_11176)"
          />
        </g>
        <g filter="url(#filter3_f_144_11176)">
          <path
            d="M21.2056 12.635L18.782 14.2999C18.6756 14.9529 18.4367 15.5952 18.087 16.1809C17.6863 16.8519 17.191 17.3628 16.6833 17.7519C15.1656 18.9149 13.3971 19.1543 12.1661 19.1553C10.8936 21.3225 10.6705 22.408 12.2556 24.1571C14.2169 24.1557 15.9556 23.8017 17.4893 23.1387C18.598 22.6594 19.5802 22.0343 20.4696 21.2309C21.6447 20.1694 22.5651 18.8564 23.1933 17.3458C23.8214 15.8351 24.1573 14.1269 24.1573 12.2749L21.2056 12.635Z"
            fill="url(#paint3_radial_144_11176)"
          />
        </g>
        <g filter="url(#filter4_f_144_11176)">
          <path
            d="M12.0762 9.59863V14.5628H23.7367C23.8393 13.883 24.1784 13.0032 24.1784 12.2749C24.1784 11.4238 24.093 10.3842 23.9481 9.59863H12.0762Z"
            fill="#3086FF"
          />
        </g>
        <g filter="url(#filter5_f_144_11176)">
          <path
            d="M2.93614 3.82422C2.21656 4.61153 1.60182 5.49276 1.1144 6.4458C0.278183 8.0757 -0.179688 10.0572 -0.179688 11.9993C-0.179688 12.0266 -0.177422 12.0534 -0.17724 12.0807C0.193097 12.7908 4.93829 12.6548 5.17746 12.0807C5.17716 12.054 5.17415 12.0278 5.17415 12.001C5.17415 11.2044 5.30872 10.6173 5.55401 9.8972C5.8566 9.00893 6.3304 8.19095 6.93626 7.48619C7.0736 7.31085 7.43993 6.9339 7.54681 6.7078C7.58753 6.62168 7.4729 6.57334 7.46649 6.54303C7.45932 6.50912 7.30563 6.53639 7.2712 6.51114C7.16188 6.43095 6.94539 6.38907 6.81394 6.35185C6.53296 6.2723 6.06731 6.09685 5.80867 5.91498C4.99113 5.3401 3.71527 4.65341 2.93614 3.82422Z"
            fill="url(#paint4_radial_144_11176)"
          />
        </g>
        <g filter="url(#filter6_f_144_11176)">
          <path
            d="M5.8262 6.54615C7.72201 7.69454 8.26721 5.9665 9.52766 5.42575L7.33507 0.878906C6.52851 1.2179 5.76648 1.63907 5.05943 2.13117C4.00351 2.86608 3.07105 3.76289 2.30078 4.78347L5.8262 6.54615Z"
            fill="url(#paint5_radial_144_11176)"
          />
        </g>
        <g filter="url(#filter7_f_144_11176)">
          <path
            d="M6.59746 18.1469C4.05259 19.0657 3.65418 19.0986 3.41992 20.6758C3.86757 21.1126 4.34854 21.5167 4.85964 21.883C6.23108 22.8661 8.86914 24.1754 12.243 24.1754C12.2469 24.1754 12.2507 24.1751 12.2547 24.1751V19.0676C12.2521 19.0676 12.2492 19.0678 12.2467 19.0678C10.9833 19.0678 9.9737 18.736 8.93857 18.1589C8.68335 18.0166 8.22032 18.3987 7.98494 18.2279C7.66031 17.9923 6.87903 18.4309 6.59746 18.1469Z"
            fill="url(#paint6_radial_144_11176)"
          />
        </g>
        <g opacity="0.5" filter="url(#filter8_f_144_11176)">
          <path
            d="M10.7646 18.9067V24.0866C11.2367 24.1419 11.728 24.1754 12.2433 24.1754C12.76 24.1754 13.2598 24.1489 13.7455 24.1001V18.9417C13.2012 19.0347 12.6886 19.0678 12.247 19.0678C11.7384 19.0678 11.2439 19.0086 10.7646 18.9067Z"
            fill="url(#paint7_linear_144_11176)"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_f_144_11176"
          x="-0.251443"
          y="12.0069"
          width="9.46675"
          height="8.60835"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="0.0368542"
            result="effect1_foregroundBlur_144_11176"
          />
        </filter>
        <filter
          id="filter1_f_144_11176"
          x="11.8413"
          y="-0.161111"
          width="8.78316"
          height="6.88667"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="0.0368542"
            result="effect1_foregroundBlur_144_11176"
          />
        </filter>
        <filter
          id="filter2_f_144_11176"
          x="2.79348"
          y="-0.176247"
          width="9.62398"
          height="7.64839"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="0.0368542"
            result="effect1_foregroundBlur_144_11176"
          />
        </filter>
        <filter
          id="filter3_f_144_11176"
          x="11.065"
          y="12.2012"
          width="13.166"
          height="12.0297"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="0.0368542"
            result="effect1_foregroundBlur_144_11176"
          />
        </filter>
        <filter
          id="filter4_f_144_11176"
          x="12.0025"
          y="9.52492"
          width="12.25"
          height="5.11177"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="0.0368542"
            result="effect1_foregroundBlur_144_11176"
          />
        </filter>
        <filter
          id="filter5_f_144_11176"
          x="-0.253396"
          y="3.75051"
          width="7.88277"
          height="8.88667"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="0.0368542"
            result="effect1_foregroundBlur_144_11176"
          />
        </filter>
        <filter
          id="filter6_f_144_11176"
          x="1.78258"
          y="0.360706"
          width="8.26296"
          height="7.08962"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="0.2591"
            result="effect1_foregroundBlur_144_11176"
          />
        </filter>
        <filter
          id="filter7_f_144_11176"
          x="3.34621"
          y="18.0528"
          width="8.98238"
          height="6.19624"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="0.0368542"
            result="effect1_foregroundBlur_144_11176"
          />
        </filter>
        <filter
          id="filter8_f_144_11176"
          x="10.6909"
          y="18.833"
          width="3.12789"
          height="5.41597"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="0.0368542"
            result="effect1_foregroundBlur_144_11176"
          />
        </filter>
        <radialGradient
          id="paint0_radial_144_11176"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(-0.498722 -11.9519 17.9311 -0.717223 9.02993 20.3617)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.141612" stop-color="#1ABD4D" />
          <stop offset="0.247515" stop-color="#6EC30D" />
          <stop offset="0.311547" stop-color="#8AC502" />
          <stop offset="0.366013" stop-color="#A2C600" />
          <stop offset="0.445673" stop-color="#C8C903" />
          <stop offset="0.540305" stop-color="#EBCB03" />
          <stop offset="0.615636" stop-color="#F7CD07" />
          <stop offset="0.699345" stop-color="#FDCD04" />
          <stop offset="0.771242" stop-color="#FDCE05" />
          <stop offset="0.860566" stop-color="#FFCE0A" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_144_11176"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(8.46967 -2.03557e-05 -1.19045e-05 10.7093 20.2147 6.3974)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.408458" stop-color="#FB4E5A" />
          <stop offset="1" stop-color="#FF4540" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_144_11176"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(-11.8666 6.43492 8.91875 15.766 15.5886 -1.65274)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.231273" stop-color="#FF4541" />
          <stop offset="0.311547" stop-color="#FF4540" />
          <stop offset="0.457516" stop-color="#FF4640" />
          <stop offset="0.540305" stop-color="#FF473F" />
          <stop offset="0.699346" stop-color="#FF5138" />
          <stop offset="0.771242" stop-color="#FF5B33" />
          <stop offset="0.860566" stop-color="#FF6C29" />
          <stop offset="1" stop-color="#FF8C18" />
        </radialGradient>
        <radialGradient
          id="paint3_radial_144_11176"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(-21.5204 -27.5047 -10.3696 7.77752 12.432 22.6038)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.131546" stop-color="#0CBA65" />
          <stop offset="0.209784" stop-color="#0BB86D" />
          <stop offset="0.297297" stop-color="#09B479" />
          <stop offset="0.396257" stop-color="#08AD93" />
          <stop offset="0.477124" stop-color="#0AA6A9" />
          <stop offset="0.568425" stop-color="#0D9CC6" />
          <stop offset="0.667385" stop-color="#1893DD" />
          <stop offset="0.768727" stop-color="#258BF1" />
          <stop offset="0.858506" stop-color="#3086FF" />
        </radialGradient>
        <radialGradient
          id="paint4_radial_144_11176"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(-1.52295 12.8522 18.1501 2.06168 11.2034 2.16435)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.366013" stop-color="#FF4E3A" />
          <stop offset="0.457516" stop-color="#FF8A1B" />
          <stop offset="0.540305" stop-color="#FFA312" />
          <stop offset="0.615636" stop-color="#FFB60C" />
          <stop offset="0.771242" stop-color="#FFCD0A" />
          <stop offset="0.860566" stop-color="#FECF0A" />
          <stop offset="0.915033" stop-color="#FECF08" />
          <stop offset="1" stop-color="#FDCD01" />
        </radialGradient>
        <radialGradient
          id="paint5_radial_144_11176"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(-4.40212 4.76677 -13.7322 -12.1566 9.06171 2.03076)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.315904" stop-color="#FF4C3C" />
          <stop offset="0.603818" stop-color="#FF692C" />
          <stop offset="0.726837" stop-color="#FF7825" />
          <stop offset="0.884534" stop-color="#FF8D1B" />
          <stop offset="1" stop-color="#FF9F13" />
        </radialGradient>
        <radialGradient
          id="paint6_radial_144_11176"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(-11.8666 -6.43492 8.91876 -15.766 15.5886 25.6527)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.231273" stop-color="#0FBC5F" />
          <stop offset="0.311547" stop-color="#0FBC5F" />
          <stop offset="0.366013" stop-color="#0FBC5E" />
          <stop offset="0.457516" stop-color="#0FBC5D" />
          <stop offset="0.540305" stop-color="#12BC58" />
          <stop offset="0.699346" stop-color="#28BF3C" />
          <stop offset="0.771242" stop-color="#38C02B" />
          <stop offset="0.860566" stop-color="#52C218" />
          <stop offset="0.915033" stop-color="#67C30F" />
          <stop offset="1" stop-color="#86C504" />
        </radialGradient>
        <linearGradient
          id="paint7_linear_144_11176"
          x1="10.7646"
          y1="21.5411"
          x2="13.7455"
          y2="21.5411"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0FBC5C" />
          <stop offset="1" stop-color="#0CBA65" />
        </linearGradient>
      </defs>
    </SvgLogo>
  );
};

const WatiLogo = (props: LogoComponentProps) => {
  return (
    <SvgLogo {...props}>
      <path
        d="M6.96847 19.0962H14.0453L18.2747 24.0001V19.0962H20.0815C22.2372 19.0962 24.0002 17.0501 24.0002 14.5483V8.08934C24.0002 5.58759 22.2372 3.5415 20.0815 3.5415H6.96847C4.81282 3.5415 3.0498 5.58759 3.0498 8.08934V14.5483C3.0498 17.0501 4.81282 19.0962 6.96847 19.0962Z"
        fill="#00E785"
      />
      <path
        d="M15.9911 22.5998L11.4434 17.3265H4.68106C2.10038 17.3265 0 14.8889 0 11.8938V5.43263C0 2.43761 2.10038 0 4.68106 0H17.7941C20.3748 0 22.4752 2.43761 22.4752 5.43263V11.8916C22.4752 14.8867 20.3748 17.3243 17.7941 17.3243H15.9873V15.5547H17.7941C19.5343 15.5547 20.9504 13.9112 20.9504 11.8916V5.43263C20.9504 3.41309 19.5343 1.76959 17.7941 1.76959H4.68106C2.94091 1.76959 1.52477 3.41309 1.52477 5.43263V11.8916C1.52477 13.9112 2.94091 15.5547 4.68106 15.5547H12.0743L16.0044 20.1114L15.9911 22.5976V22.5998Z"
        fill="#1D1D1B"
      />
    </SvgLogo>
  );
};

const FolkLogo = (props: LogoComponentProps) => {
  return (
    <SvgLogo {...props}>
      <path
        d="M12.0234 24C5.38012 24 0 18.6047 0 12C0 5.39535 5.38012 0 12.0234 0C18.6667 0 24.0468 5.39535 24.0468 12C24.0468 18.6047 18.6199 24 12.0234 24ZM12.0234 0.744186C5.80117 0.744186 0.748538 5.81395 0.748538 12C0.748538 18.186 5.80117 23.2558 12.0234 23.2558C18.2456 23.2558 23.2982 18.186 23.2982 12C23.2515 5.81395 18.1988 0.744186 12.0234 0.744186Z"
        fill="black"
      />
      <path
        d="M11.8363 19.5813H12.2574C16.234 19.5813 19.4621 16.5115 19.6024 12.465C19.6024 12.2324 19.4153 12.0464 19.2281 12.0464H4.91236C4.67844 12.0464 4.53809 12.2324 4.53809 12.465C4.63165 16.5115 7.85972 19.5813 11.8363 19.5813Z"
        fill="black"
      />
    </SvgLogo>
  );
};

const LinkedinLogo = (props: LogoComponentProps) => {
  return (
    <SvgLogo {...props}>
      <path
        d="M20.4491 20.4496H16.8931V14.8805C16.8931 13.5525 16.8694 11.8429 15.0436 11.8429C13.1915 11.8429 12.9081 13.2899 12.9081 14.7838V20.4492H9.35203V8.99689H12.7658V10.562H12.8136C13.1553 9.97782 13.649 9.49726 14.2421 9.17149C14.8352 8.84572 15.5056 8.68693 16.1819 8.71203C19.7861 8.71203 20.4506 11.0828 20.4506 14.167L20.4491 20.4496ZM5.33963 7.43144C4.93148 7.43151 4.53247 7.31055 4.19307 7.08385C3.85367 6.85715 3.58913 6.53489 3.43287 6.15783C3.27661 5.78077 3.23566 5.36584 3.31521 4.96551C3.39477 4.56517 3.59125 4.19743 3.8798 3.90876C4.16835 3.6201 4.53602 3.42348 4.93631 3.34378C5.3366 3.26408 5.75152 3.30488 6.12863 3.46101C6.50573 3.61713 6.82807 3.88158 7.05489 4.22091C7.2817 4.56025 7.40281 4.95922 7.40288 5.36738C7.40293 5.63839 7.34959 5.90675 7.24593 6.15715C7.14227 6.40754 6.99032 6.63507 6.79873 6.82674C6.60714 7.0184 6.37966 7.17045 6.1293 7.27421C5.87895 7.37796 5.61062 7.43139 5.33963 7.43144ZM7.11765 20.4496H3.5579V8.99689H7.11765V20.4496ZM22.222 0.00163516H1.77099C1.30681 -0.00360329 0.859518 0.175663 0.52744 0.500042C0.195362 0.824421 0.00566506 1.26737 0 1.73156V22.2681C0.00547117 22.7325 0.195057 23.1758 0.527123 23.5005C0.85919 23.8252 1.30658 24.0048 1.77099 23.9999H22.222C22.6873 24.0057 23.1359 23.8266 23.4693 23.5019C23.8027 23.1772 23.9936 22.7334 24 22.2681V1.73008C23.9934 1.26497 23.8024 0.821515 23.469 0.497144C23.1356 0.172773 22.6871 -0.00598143 22.222 0.000152822"
        fill="#0A66C2"
      />
    </SvgLogo>
  );
};

const ClaudeLogo = (props: LogoComponentProps) => {
  return (
    <SvgLogo {...props}>
      <path
        d="M5.16577 16.3018L9.637 13.8013L9.71181 13.5833L9.637 13.4629H9.41833L8.67025 13.417L6.11526 13.3482L3.89979 13.2564L1.75337 13.1417L1.21245 13.027L0.706055 12.3617L0.757845 12.0291L1.21245 11.7251L1.8627 11.7824L3.30132 11.8799L5.45925 12.0291L7.02447 12.1208L9.34352 12.3617H9.71181L9.7636 12.2126L9.637 12.1208L9.53918 12.0291L7.30644 10.5207L4.88956 8.92626L3.62357 8.00861L2.93879 7.54405L2.59352 7.10817L2.44391 6.15611L3.06539 5.47361L3.89979 5.53096L4.1127 5.58832L4.95861 6.2364L6.76552 7.63008L9.12485 9.36214L9.47012 9.6489L9.60823 9.5514L9.62549 9.48258L9.47012 9.22449L8.18687 6.91317L6.81731 4.5617L6.20733 3.5867L6.04621 3.0017C5.98866 2.76082 5.94838 2.56008 5.94838 2.31346L6.65618 1.35567L7.04749 1.22949L7.99122 1.35567L8.38828 1.69979L8.97524 3.03611L9.92472 5.14096L11.3979 8.00287L11.8295 8.8517L12.0596 9.63743L12.146 9.87832H12.2956V9.74067L12.4164 8.12905L12.6408 6.15037L12.8595 3.6039L12.9343 2.88699L13.2911 2.0267L13.9989 1.56214L14.5513 1.82596L15.0059 2.47405L14.9426 2.89273L14.6722 4.64199L14.1428 7.38346L13.7975 9.21876H13.9989L14.2291 8.98935L15.1613 7.75626L16.7265 5.80626L17.4171 5.03199L18.2227 4.17743L18.7406 3.77023H19.7188L20.4382 4.83699L20.1159 5.93817L19.1089 7.2114L18.2745 8.28964L17.0775 9.89552L16.3295 11.1802L16.3985 11.2835L16.5769 11.2663L19.2815 10.6927L20.7431 10.4289L22.4867 10.1307L23.2751 10.4977L23.3614 10.8705L23.0507 11.6333L21.1862 12.0921L18.9995 12.528L15.7425 13.2966L15.7022 13.3252L15.7483 13.3826L17.2156 13.5202L17.8429 13.5546H19.3793L22.2393 13.7668L22.9874 14.2601L23.4362 14.8623L23.3614 15.3211L22.2105 15.9061L20.6568 15.5391L17.0315 14.6788L15.7885 14.3691H15.6159V14.4723L16.6517 15.4817L18.5507 17.1908L20.9273 19.3932L21.0481 19.938L20.7431 20.3682L20.4209 20.3223L18.332 18.7566L17.5264 18.0511L15.7022 16.5198H15.5814V16.6804L16.0015 17.2941L18.2227 20.6205L18.3378 21.6414L18.1766 21.9741L17.6012 22.1748L16.9682 22.0601L15.6677 20.242L14.3269 18.1945L13.2451 16.3592L13.1127 16.4338L12.474 23.2874L12.1747 23.6373L11.4842 23.9011L10.9087 23.4652L10.6038 22.7598L10.9087 21.3661L11.277 19.548L11.5763 18.1027L11.8467 16.3076L12.0078 15.7111L11.9963 15.671L11.864 15.6882L10.5059 17.5464L8.44007 20.328L6.8058 22.0716L6.41449 22.2264L5.73547 21.8766L5.79877 21.2514L6.17856 20.6951L8.44007 17.8274L9.80388 16.0495L10.6843 15.0229L10.6786 14.8738H10.6268L4.6191 18.7623L3.54877 18.8999L3.08841 18.4698L3.14595 17.7643L3.36462 17.5349L5.17153 16.2961L5.16577 16.3018Z"
        fill="#D97757"
      />
    </SvgLogo>
  );
};

const GPTLogo = (props: LogoComponentProps) => {
  return (
    <SvgLogo {...props}>
      <path
        d="M9.20509 8.76496V6.5053C9.20509 6.31498 9.27649 6.17219 9.44293 6.07715L13.9861 3.46073C14.6046 3.10398 15.342 2.93754 16.103 2.93754C18.9573 2.93754 20.7651 5.14968 20.7651 7.50439C20.7651 7.67083 20.7651 7.86114 20.7412 8.05146L16.0316 5.29225C15.7462 5.12581 15.4607 5.12581 15.1753 5.29225L9.20509 8.76496ZM19.8135 17.5658V12.1662C19.8135 11.8331 19.6708 11.5953 19.3854 11.4288L13.4152 7.95618L15.3656 6.83818C15.5321 6.74313 15.6749 6.74313 15.8413 6.83818L20.3845 9.45459C21.6928 10.2158 22.5728 11.8331 22.5728 13.4029C22.5728 15.2106 21.5025 16.8759 19.8135 17.5658ZM7.80173 12.8086L5.8513 11.6669C5.68486 11.5719 5.61346 11.4291 5.61346 11.2388V6.00598C5.61346 3.46096 7.56389 1.53418 10.2042 1.53418C11.2033 1.53418 12.1307 1.86728 12.9159 2.46187L8.2301 5.17356C7.94475 5.34 7.80195 5.57783 7.80195 5.91094L7.80173 12.8086ZM12 15.2347L9.20509 13.6649V10.3349L12 8.76519L14.7947 10.3349V13.6649L12 15.2347ZM13.7958 22.4657C12.7967 22.4657 11.8693 22.1327 11.0841 21.538L15.7699 18.8263C16.0553 18.66 16.198 18.422 16.198 18.0889V11.191L18.1723 12.3327C18.3388 12.4277 18.4102 12.5705 18.4102 12.7608V17.9937C18.4102 20.5387 16.4359 22.4657 13.7958 22.4657ZM8.15848 17.1615L3.61528 14.545C2.30696 13.7838 1.42701 12.1665 1.42701 10.5967C1.42701 8.76519 2.52115 7.12399 4.20987 6.43413V11.8572C4.20987 12.1903 4.35266 12.4282 4.63802 12.5946L10.5846 16.0434L8.63415 17.1615C8.46771 17.2565 8.32492 17.2565 8.15848 17.1615ZM7.897 21.0623C5.20919 21.0623 3.23488 19.0405 3.23488 16.543C3.23488 16.3527 3.25875 16.1624 3.2824 15.9721L7.96817 18.6838C8.25352 18.8503 8.53911 18.8503 8.82446 18.6838L14.7947 15.2349V17.4946C14.7947 17.6849 14.7233 17.8277 14.5568 17.9227L10.0136 20.5392C9.39518 20.896 8.65803 21.0623 7.897 21.0623ZM13.7958 23.8927C16.6739 23.8927 19.0762 21.8472 19.6235 19.1355C22.2874 18.4457 24 15.9482 24 13.4032C24 11.7381 23.2865 10.1208 22.002 8.95527C22.121 8.45573 22.1924 7.95618 22.1924 7.45687C22.1924 4.05555 19.4331 1.5103 16.2458 1.5103C15.6037 1.5103 14.9852 1.60534 14.3668 1.81953C13.2963 0.772919 11.8215 0.106934 10.2042 0.106934C7.32606 0.106934 4.92383 2.15241 4.37653 4.8641C1.7126 5.55396 0 8.05146 0 10.5964C0 12.2615 0.713506 13.8788 1.99795 15.0444C1.87904 15.5439 1.80764 16.0434 1.80764 16.5428C1.80764 19.9441 4.56685 22.4893 7.75421 22.4893C8.39632 22.4893 9.01478 22.3944 9.63324 22.1801C10.7035 23.2267 12.1783 23.8927 13.7958 23.8927Z"
        fill="black"
      />
    </SvgLogo>
  );
};

const CalcomLogo = (props: LogoComponentProps) => {
  return (
    <SvgLogo height={6} viewBox="0 0 24 6" {...props}>
      <g clip-path="url(#clip0_676_49393)">
        <path
          d="M2.39007 5.23127C1.02681 5.23127 0 4.19929 0 2.92522C0 1.64693 0.974376 0.606445 2.39007 0.606445C3.1416 0.606445 3.66154 0.827281 4.0679 1.33266L3.41249 1.85502C3.13723 1.57473 2.80515 1.43458 2.39007 1.43458C1.46812 1.43458 0.961266 2.10983 0.961266 2.92522C0.961266 3.74063 1.51618 4.40313 2.39007 4.40313C2.80078 4.40313 3.15034 4.263 3.42561 3.9827L4.07228 4.52629C3.68341 5.01043 3.15034 5.23127 2.39007 5.23127Z"
          fill="#292929"
        />
        <path
          d="M6.8948 1.83763H7.7774V5.15017H6.8948V4.66604C6.71128 5.01004 6.40541 5.23936 5.81993 5.23936C4.88488 5.23936 4.1377 4.4622 4.1377 3.50665C4.1377 2.5511 4.88488 1.77393 5.81993 1.77393C6.40106 1.77393 6.71128 2.00326 6.8948 2.34725V1.83763ZM6.92101 3.50665C6.92101 2.98854 6.5496 2.5596 5.96412 2.5596C5.40045 2.5596 5.03342 2.99276 5.03342 3.50665C5.03342 4.00776 5.40045 4.4537 5.96412 4.4537C6.54525 4.4537 6.92101 4.02051 6.92101 3.50665Z"
          fill="#292929"
        />
        <path d="M8.40234 0.5H9.28495V5.14607H8.40234V0.5Z" fill="#292929" />
        <path
          d="M9.67773 4.70866C9.67773 4.43686 9.90495 4.20752 10.2152 4.20752C10.5254 4.20752 10.7439 4.43686 10.7439 4.70866C10.7439 4.98895 10.521 5.21827 10.2152 5.21827C9.90932 5.21827 9.67773 4.98895 9.67773 4.70866Z"
          fill="#292929"
        />
        <path
          d="M14.122 4.61508C13.7943 4.99729 13.2962 5.23936 12.7063 5.23936C11.6533 5.23936 10.8799 4.4622 10.8799 3.50665C10.8799 2.5511 11.6533 1.77393 12.7063 1.77393C13.2743 1.77393 13.7681 2.00326 14.0958 2.36424L13.4141 2.91208C13.2437 2.70823 13.0209 2.55535 12.7063 2.55535C12.1426 2.55535 11.7756 2.98854 11.7756 3.5024C11.7756 4.01626 12.1426 4.44945 12.7063 4.44945C13.0471 4.44945 13.283 4.27958 13.4578 4.05024L14.122 4.61508Z"
          fill="#292929"
        />
        <path
          d="M14.1963 3.50665C14.1963 2.5511 14.9697 1.77393 16.0227 1.77393C17.0757 1.77393 17.8491 2.5511 17.8491 3.50665C17.8491 4.4622 17.0757 5.23936 16.0227 5.23936C14.9697 5.23511 14.1963 4.4622 14.1963 3.50665ZM16.9534 3.50665C16.9534 2.98854 16.5863 2.5596 16.0227 2.5596C15.459 2.55535 15.092 2.98854 15.092 3.50665C15.092 4.02051 15.459 4.4537 16.0227 4.4537C16.5863 4.4537 16.9534 4.02051 16.9534 3.50665Z"
          fill="#292929"
        />
        <path
          d="M23.8176 3.12481V5.14631H22.9351V3.3329C22.9351 2.75958 22.6555 2.51327 22.236 2.51327C21.8428 2.51327 21.5631 2.70013 21.5631 3.3329V5.14631H20.6805V3.3329C20.6805 2.75958 20.3965 2.51327 19.9814 2.51327C19.5882 2.51327 19.243 2.70013 19.243 3.3329V5.14631H18.3604V1.83377H19.243V2.29243C19.4265 1.93569 19.7586 1.75732 20.2698 1.75732C20.7548 1.75732 21.1611 1.98665 21.384 2.37312C21.6068 1.97816 21.9345 1.75732 22.5287 1.75732C23.2541 1.76157 23.8176 2.28818 23.8176 3.12481Z"
          fill="#292929"
        />
      </g>
      <defs>
        <clipPath id="clip0_676_49393">
          <rect
            width="24"
            height="5"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </SvgLogo>
  );
};

const AstraLogo = (props: LogoComponentProps) => {
  return (
    <SvgLogo {...props}>
      <path
        d="M20.4043 11.4033C20.5247 11.4033 20.623 11.5023 20.623 11.623V16.4268C20.623 16.5424 20.5617 16.6491 20.4619 16.707L11.7188 21.7705C11.5734 21.8547 11.3916 21.7492 11.3916 21.5811V20.2051L14.4951 17.0918L14.21 16.8057L11.3916 19.6328V15.5977C11.3916 13.2817 13.2633 11.4033 15.5723 11.4033H20.4043ZM17.0293 14.0576C16.3733 14.3092 15.6419 14.3092 14.9854 14.0576C14.8722 14.0139 14.7596 14.1277 14.8027 14.2412C15.0535 14.8998 15.054 15.6334 14.8027 16.292C14.7592 16.4055 14.8718 16.5179 14.9854 16.4746C15.6418 16.2227 16.3729 16.2231 17.0293 16.4746C17.1424 16.5183 17.2549 16.4054 17.2119 16.292C16.9611 15.6338 16.9611 14.8998 17.2119 14.2412C17.2555 14.1278 17.1424 14.0145 17.0293 14.0576Z"
        fill="url(#paint0_linear_100604_2868)"
      />
      <path
        d="M10.4189 0.229492C10.5643 0.145169 10.7461 0.251276 10.7461 0.419922V6.40234C10.7461 8.71871 8.87398 10.5967 6.56543 10.5967H3.8418L6.80469 7.625L6.51953 7.33887L3.27148 10.5967H1.7334C1.61303 10.5967 1.51567 10.4987 1.51562 10.3779V5.57324C1.5158 5.45811 1.57694 5.35077 1.67676 5.29297L10.4189 0.229492ZM7.94824 5.45117C7.4376 5.45117 7.02344 5.86663 7.02344 6.37891C7.02356 6.89107 7.43768 7.30664 7.94824 7.30664C8.45872 7.30653 8.87292 6.891 8.87305 6.37891C8.87305 5.8667 8.45879 5.45128 7.94824 5.45117Z"
        fill="url(#paint1_linear_100604_2868)"
      />
      <path
        d="M10.7461 21.582C10.7459 21.7487 10.5638 21.8539 10.418 21.7705L10.0459 21.5557L10.7461 20.8525V21.582ZM6.56543 11.4043C7.6248 11.4043 8.59278 11.8008 9.33105 12.4561C9.40374 12.5189 9.47476 12.586 9.54199 12.6553C9.57059 12.6844 9.59874 12.7141 9.62598 12.7441C9.69004 12.8134 9.752 12.8846 9.81152 12.958C10.3962 13.6799 10.746 14.5978 10.7461 15.5977V20.2803L9.68359 21.3457L9.43262 21.2012L9.11621 21.0166L4.46289 18.3232L9.81055 12.958C9.75113 12.8848 9.68991 12.8133 9.62598 12.7441C9.59874 12.7141 9.56961 12.6844 9.54102 12.6553L4.10156 18.1133L3.8916 17.9922L1.67578 16.708C1.57736 16.6496 1.51466 16.5415 1.51465 16.4268V12.9316L3.03711 11.4043H6.56543ZM4.16309 18.1494H4.16406H4.16309ZM1.51465 12.3584V11.623C1.51465 11.5018 1.61343 11.4044 1.73242 11.4043H2.46582L1.51465 12.3584Z"
        fill="url(#paint2_linear_100604_2868)"
      />
      <path
        d="M11.3916 0.418945C11.3919 0.250663 11.5735 0.145494 11.7188 0.229492L20.4619 5.29297C20.5617 5.35082 20.6229 5.45813 20.623 5.57324V10.3779C20.6229 10.4986 20.5246 10.5967 20.4043 10.5967H15.5723C14.6149 10.5967 13.733 10.2738 13.0283 9.73047L15.1279 7.62402L14.8428 7.33789L12.7197 9.46777C11.9024 8.70295 11.3916 7.61243 11.3916 6.40234V0.418945ZM16.0156 3.93262C15.8944 3.92624 15.8811 4.02783 15.877 4.12305C15.8642 4.40048 15.8645 4.67855 15.8223 4.95508C15.7028 5.73905 15.3067 6.12655 14.5234 6.20312C14.2823 6.22635 14.0399 6.23497 13.7979 6.25C13.7034 6.25592 13.576 6.23311 13.5732 6.37109C13.5701 6.52424 13.7071 6.50352 13.8066 6.50488C14.1394 6.50899 14.4718 6.52579 14.7969 6.60547C15.4043 6.7545 15.7143 7.10407 15.8125 7.72656C15.8593 8.02329 15.8673 8.32209 15.876 8.62109C15.8787 8.71542 15.8884 8.80469 16.002 8.8252C16.1302 8.8055 16.1295 8.71062 16.1309 8.61816C16.1354 8.29055 16.1549 7.9648 16.2217 7.64355C16.3534 7.00922 16.6953 6.68381 17.3379 6.57617C17.6258 6.52788 17.916 6.50627 18.208 6.50488C18.3098 6.50443 18.445 6.51773 18.4404 6.36914C18.4362 6.23772 18.3101 6.25545 18.2139 6.25C17.9785 6.23724 17.7427 6.2265 17.5078 6.20508C16.6957 6.13023 16.2652 5.7056 16.1816 4.89258C16.1553 4.63744 16.1463 4.37955 16.1309 4.12305C16.1254 4.03701 16.1233 3.93832 16.0156 3.93262Z"
        fill="url(#paint3_linear_100604_2868)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_100604_2868"
          x1="11.3916"
          y1="16.6017"
          x2="20.623"
          y2="16.6017"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#1A6DFF" />
          <stop offset="1" stop-color="#2F4AD1" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_100604_2868"
          x1="1.51563"
          y1="5.39863"
          x2="10.7461"
          y2="5.39863"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2F4AD1" />
          <stop offset="1" stop-color="#1A6DFF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_100604_2868"
          x1="1.51465"
          y1="16.602"
          x2="10.7461"
          y2="16.602"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2F4AD1" />
          <stop offset="1" stop-color="#1A6DFF" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_100604_2868"
          x1="11.3916"
          y1="5.39816"
          x2="20.623"
          y2="5.39816"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#1A6DFF" />
          <stop offset="1" stop-color="#2F4AD1" />
        </linearGradient>
      </defs>
    </SvgLogo>
  );
};

const ClearbitLogo = (props: LogoComponentProps) => {
  return (
    <SvgLogo {...props}>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M24 12V17.5903L23.9986 17.8792C23.979 19.8909 23.7486 20.6635 23.3322 21.4421C22.8964 22.2569 22.2569 22.8964 21.4421 23.3322L21.3334 23.3891C20.5527 23.7881 19.72 24 17.5903 24H12V12H24Z"
        fill="url(#paint0_linear_100663_2448)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M21.4421 0.667832C22.2569 1.1036 22.8964 1.74307 23.3322 2.55789L23.3891 2.66661C23.7881 3.44735 24 4.27997 24 6.40971V12H12V0H17.5903C19.8191 0 20.6273 0.232064 21.4421 0.667832Z"
        fill="url(#paint1_linear_100663_2448)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 0V24H6.40971L6.12083 23.9986C4.10906 23.979 3.33649 23.7486 2.55789 23.3322C1.74307 22.8964 1.1036 22.2569 0.667832 21.4421L0.610939 21.3334C0.211895 20.5527 0 19.72 0 17.5903V6.40971C0 4.18092 0.232064 3.3727 0.667832 2.55789C1.1036 1.74307 1.74307 1.1036 2.55789 0.667832L2.66661 0.610939C3.44735 0.211895 4.27997 0 6.40971 0H12Z"
        fill="url(#paint2_linear_100663_2448)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_100663_2448"
          x1="612"
          y1="12"
          x2="1212"
          y2="1212"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#DEF2FE" />
          <stop offset="1" stop-color="#DBF1FE" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_100663_2448"
          x1="12"
          y1="0"
          x2="612"
          y2="1200"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#57BCFD" />
          <stop offset="1" stop-color="#51B5FD" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_100663_2448"
          x1="450"
          y1="1.78814e-05"
          x2="1470"
          y2="2040"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#1CA7FD" />
          <stop offset="1" stop-color="#148CFC" />
        </linearGradient>
      </defs>
    </SvgLogo>
  );
};

const GoogleCalendarLogo = (props: LogoComponentProps) => {
  return (
    <SvgLogo {...props}>
      <path
        d="M18.316 5.68429L12.6318 5.05273L5.68441 5.68429L5.05273 12.0001L5.68429 18.316L12.0001 19.1055L18.316 18.316L18.9475 11.8423L18.316 5.68429Z"
        fill="white"
      />
      <path
        d="M8.27525 15.4833C7.80317 15.1643 7.47629 14.6986 7.29785 14.0828L8.39369 13.6312C8.49317 14.0102 8.66681 14.3038 8.91473 14.5122C9.16109 14.7207 9.46109 14.8233 9.81161 14.8233C10.1701 14.8233 10.478 14.7143 10.7353 14.4964C10.9925 14.2785 11.1221 14.0006 11.1221 13.6643C11.1221 13.3202 10.9863 13.039 10.7147 12.8212C10.4432 12.6034 10.1021 12.4943 9.69473 12.4943H9.06161V11.4096H9.62993C9.98045 11.4096 10.2758 11.315 10.5158 11.1255C10.7558 10.936 10.8758 10.677 10.8758 10.347C10.8758 10.0534 10.7684 9.81965 10.5537 9.64445C10.339 9.46925 10.0673 9.38081 9.73733 9.38081C9.41525 9.38081 9.15941 9.46613 8.96993 9.63821C8.78045 9.81029 8.64305 10.0218 8.55629 10.2713L7.47161 9.81977C7.61525 9.41237 7.87901 9.05237 8.26577 8.74133C8.65265 8.43029 9.14681 8.27393 9.74681 8.27393C10.1905 8.27393 10.5899 8.35925 10.9437 8.53133C11.2973 8.70341 11.5753 8.94185 11.7758 9.24497C11.9763 9.54965 12.0758 9.89081 12.0758 10.2696C12.0758 10.6565 11.9827 10.9833 11.7963 11.2517C11.6099 11.5202 11.381 11.7254 11.1094 11.8691V11.9338C11.4679 12.0838 11.7599 12.3128 11.9905 12.6207C12.2194 12.9286 12.3346 13.2965 12.3346 13.726C12.3346 14.1555 12.2257 14.5391 12.0077 14.8755C11.7898 15.2118 11.4883 15.477 11.1062 15.6696C10.7225 15.8622 10.2915 15.9602 9.81305 15.9602C9.25889 15.9617 8.74733 15.8022 8.27525 15.4833Z"
        fill="#1A73E8"
      />
      <path
        d="M14.9996 10.0453L13.8027 10.9153L13.2012 10.0027L15.3596 8.4458H16.187V15.7894H14.9996V10.0453Z"
        fill="#1A73E8"
      />
      <path
        d="M18.3159 24L24 18.3159L21.1579 17.0527L18.3159 18.3159L17.0527 21.1579L18.3159 24Z"
        fill="#EA4335"
      />
      <path
        d="M4.4209 21.158L5.68402 24.0001H18.3156V18.3159H5.68402L4.4209 21.158Z"
        fill="#34A853"
      />
      <path
        d="M1.89468 0C0.84792 0 0 0.84792 0 1.89468V18.3157L2.84208 19.5788L5.68416 18.3157V5.68416H18.3157L19.5788 2.84208L18.3158 0H1.89468Z"
        fill="#4285F4"
      />
      <path
        d="M0 18.3159V22.1054C0 23.1523 0.84792 24.0001 1.89468 24.0001H5.68416V18.3159H0Z"
        fill="#188038"
      />
      <path
        d="M18.3154 5.68402V18.3156H23.9996V5.68402L21.1575 4.4209L18.3154 5.68402Z"
        fill="#FBBC04"
      />
      <path
        d="M23.9996 5.68416V1.89468C23.9996 0.8478 23.1517 0 22.1049 0H18.3154V5.68416H23.9996Z"
        fill="#1967D2"
      />
    </SvgLogo>
  );
};

const GoogleMailLogo = (props: LogoComponentProps) => {
  return (
    <SvgLogo {...props}>
      <g clip-path="url(#clip0_100663_2551)">
        <path
          d="M1.63636 17.9999H5.45455V8.72714L0 4.63623V16.3635C0 17.269 0.733636 17.9999 1.63636 17.9999Z"
          fill="#4285F4"
        />
        <path
          d="M18.5459 17.9999H22.3641C23.2695 17.9999 24.0004 17.2662 24.0004 16.3635V4.63623L18.5459 8.72714"
          fill="#34A853"
        />
        <path
          d="M18.5459 1.63661V8.72752L24.0004 4.63661V2.45479C24.0004 0.431157 21.6904 -0.72248 20.0732 0.491157"
          fill="#FBBC04"
        />
        <path
          d="M5.4541 8.72714V1.63623L11.9996 6.54532L18.545 1.63623V8.72714L11.9996 13.6362"
          fill="#EA4335"
        />
        <path
          d="M0 2.45479V4.63661L5.45455 8.72752V1.63661L3.92727 0.491157C2.30727 -0.72248 0 0.431157 0 2.45479Z"
          fill="#C5221F"
        />
      </g>
      <defs>
        <clipPath id="clip0_100663_2551">
          <rect width="24" height="18" fill="white" />
        </clipPath>
      </defs>
    </SvgLogo>
  );
};

const FactorsaiLogo = (props: LogoComponentProps) => {
  return (
    <SvgLogo {...props}>
      <g clip-path="url(#clip0_100663_2478)">
        <path
          d="M0.961914 16.8862H7.9983C7.9983 20.7723 4.848 23.9247 0.961914 23.9247V16.8862Z"
          fill="#FF3535"
        />
        <path
          d="M0.961914 8.44824H15.0388C15.0388 12.3355 11.8876 15.4867 8.00037 15.4867H0.961914V8.44824Z"
          fill="#FF3535"
        />
        <path
          d="M0.961914 7.04869C0.961914 3.16148 4.11312 0.0102539 8.00037 0.0102539H15.0388C15.0388 3.89749 11.8876 7.04869 8.00037 7.04869H0.961914Z"
          fill="#FF3535"
        />
        <mask
          id="mask0_100663_2478"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="16"
          height="24"
        >
          <path
            d="M0.961914 16.8862H7.9983C7.9983 20.7723 4.848 23.9247 0.961914 23.9247V16.8862Z"
            fill="#FF3535"
          />
          <path
            d="M0.961914 8.44824H15.0388C15.0388 12.3355 11.8876 15.4867 8.00037 15.4867H0.961914V8.44824Z"
            fill="#FF3535"
          />
          <path
            d="M0.961914 7.04869C0.961914 3.16148 4.11312 0.0102539 8.00037 0.0102539H15.0388C15.0388 3.89749 11.8876 7.04869 8.00037 7.04869H0.961914Z"
            fill="#FF3535"
          />
        </mask>
        <g mask="url(#mask0_100663_2478)">
          <path
            opacity="0.1"
            d="M21.3558 36.8719C31.5376 36.8719 39.7916 28.3689 39.7916 17.8798C39.7916 7.39076 31.5376 -1.1123 21.3558 -1.1123C11.1739 -1.1123 2.91992 7.39076 2.91992 17.8798C2.91992 28.3689 11.1739 36.8719 21.3558 36.8719Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_100663_2478">
          <rect
            width="14.1538"
            height="24"
            fill="white"
            transform="translate(0.922852)"
          />
        </clipPath>
      </defs>
    </SvgLogo>
  );
};

const BuiltwithLogo = (props: LogoComponentProps) => {
  return (
    <SvgLogo {...props}>
      <g clip-path="url(#clip0_100663_2521)">
        <path
          d="M0.0156522 3.97957L0.0273913 7.96304L0.12913 8.37391C0.250435 8.85913 0.426522 9.31304 0.618261 9.64174C1.22478 10.6787 2.26956 11.4026 3.52565 11.6609C4.08913 11.7783 4.96174 11.7548 5.52913 11.61C6.77348 11.2852 7.84174 10.4283 8.41304 9.28565C8.76522 8.5813 8.91783 7.6187 8.80826 6.76957C8.62826 5.37261 7.75956 4.12826 6.49565 3.44739C5.87348 3.11087 5.29043 2.97391 4.46087 2.97391C4.14391 2.97391 3.83087 2.98565 3.76435 2.99739L3.64304 3.02087V4.76217C3.64304 5.72087 3.65478 6.49565 3.67043 6.48783C4.20261 6.22174 4.22609 6.21391 4.51565 6.22957C4.68391 6.23739 4.86 6.27652 4.95391 6.31957C5.19261 6.43696 5.42348 6.68739 5.51739 6.94174C5.84609 7.81826 5.20826 8.66739 4.26913 8.60087C3.76043 8.56174 3.42391 8.26826 3.26348 7.72826C3.20087 7.51304 3.19304 7.19217 3.1813 3.74478L3.16956 0H0L0.0156522 3.97957ZM14.6465 4.32783C14.4391 4.42957 14.2435 4.63696 14.1691 4.8287C14.1183 4.96565 14.1183 5.26304 14.173 5.45478C14.2278 5.65435 14.5174 5.93217 14.7287 5.99087C15.5348 6.21391 16.2117 5.61913 16.0043 4.87565C15.9535 4.68783 15.6835 4.39435 15.48 4.30044C15.2413 4.19087 14.897 4.20261 14.6465 4.32783ZM16.6343 8.1V11.5826H18.5517V4.61739H16.6343V8.1ZM18.9157 6.99261C18.9352 9.52826 18.9352 9.56348 19.1387 10.1035C19.4557 10.9526 20.3713 11.5826 21.3809 11.6491L21.7213 11.6726V9.63783L21.5256 9.61435C21.0756 9.55957 20.9035 9.36 20.8683 8.8513L20.8487 8.56957H21.6822V6.53478H20.8604V4.61739H18.9L18.9157 6.99261ZM14.13 9.03913V11.5826H16.0474V6.49565H14.13V9.03913ZM9.00391 8.12739C9.00391 9.91174 9.01956 10.0604 9.25826 10.5574C9.51261 11.0896 10.0722 11.5435 10.6513 11.6804C10.9722 11.7548 11.5474 11.7548 11.833 11.6804C12.5648 11.4887 13.1987 10.8704 13.4374 10.1152C13.5196 9.84913 13.5235 9.78652 13.5235 8.19783V6.55435L12.5765 6.54261L11.6296 6.53478L11.6178 8.10391L11.6061 9.67304L11.4926 9.77087C11.3987 9.85304 11.3478 9.86478 11.2226 9.84913C10.9291 9.81 10.9448 9.88435 10.9213 8.12739L10.9017 6.55435L9.95478 6.54261L9.00391 6.53478V8.12739Z"
          fill="#004300"
        />
        <path
          d="M14.5282 13.2939C14.1839 13.4544 14 13.74 14 14.1274C14 14.5618 14.2739 14.8944 14.7043 14.9844C14.9508 15.0352 15.2521 15.0039 15.436 14.9061C15.7804 14.73 15.9721 14.2996 15.8782 13.9122C15.8234 13.6696 15.5808 13.3761 15.35 13.2744C15.123 13.1687 14.7747 13.1765 14.5282 13.2939ZM3.91213 16.0448C3.92778 18.4435 3.92778 18.51 4.01387 18.8113C4.16256 19.3396 4.35039 19.6761 4.70648 20.0322C5.223 20.5526 5.81778 20.7952 6.58083 20.7992C7.28909 20.8031 7.84865 20.58 8.51387 20.0165L8.71735 19.8444L8.99126 20.0752C9.6643 20.6465 10.3921 20.8892 11.1434 20.7913C11.7069 20.7209 12.0669 20.5722 12.4778 20.2435C12.9356 19.8796 13.2447 19.4452 13.4443 18.8857L13.55 18.5805L13.5617 16.0839L13.5734 13.5913L12.2508 13.5992L10.9282 13.6109L10.9086 15.7513C10.8891 17.8448 10.8891 17.8918 10.8069 18.0013C10.6073 18.2674 10.2787 18.2596 10.1417 17.9818C10.0713 17.8487 10.0673 17.6922 10.0556 15.7122L10.0439 13.5913L8.72517 13.5992L7.40648 13.6109L7.38691 15.7513C7.36735 17.8448 7.36735 17.8918 7.28517 18.0013C7.15996 18.1696 7.01517 18.2283 6.83908 18.1735C6.58082 18.0952 6.58865 18.1539 6.56517 15.7631L6.54561 13.6109L5.223 13.5992L3.90039 13.5913L3.91213 16.0448ZM16.2695 15.7318C16.2695 17.9544 16.293 18.3926 16.43 18.8544C16.7273 19.8561 17.6352 20.5526 18.7465 20.6231L19.0869 20.6465V18.6118L18.8913 18.5883C18.4804 18.5374 18.2887 18.3496 18.2417 17.9465C18.23 17.8409 18.2143 17.7118 18.2065 17.6492L18.1908 17.5435H19.0478V15.5087H18.1869V13.5913H16.2695V15.7318ZM19.4782 17.0739V20.5565H21.3956V19.0696C21.3956 17.837 21.4073 17.5592 21.4543 17.4692C21.5482 17.2813 21.7713 17.25 21.9239 17.4065L22.0217 17.5005V20.5565H23.9391V18.7252C23.9391 16.7139 23.9273 16.5965 23.7004 16.1739C23.4891 15.7748 23.1721 15.5126 22.7769 15.4109C22.3739 15.3052 21.9747 15.3561 21.6069 15.5635C21.5052 15.6183 21.4191 15.6652 21.4113 15.6652C21.4034 15.6652 21.3956 15.1996 21.3956 14.6283V13.5913H19.4782V17.0739ZM14 18.0131V20.5565H15.9173V15.4696H14V18.0131Z"
          fill="#004300"
        />
      </g>
      <defs>
        <clipPath id="clip0_100663_2521">
          <rect width="24" height="21" fill="white" />
        </clipPath>
      </defs>
    </SvgLogo>
  );
};

const SimilarwebLogo = (props: LogoComponentProps) => {
  return (
    <SvgLogo {...props}>
      <path
        d="M22.1259 6.04587C20.8715 4.09013 19.0558 2.45633 16.9726 1.62636L16.3558 1.4173C15.6752 1.20689 14.9672 1.09771 14.2548 1.09326C11.998 1.10371 10.1719 2.97061 10.1719 5.27445C10.1719 6.23403 10.4886 7.11626 11.0196 7.8187L10.7646 7.4842C10.8869 7.66608 11.0196 7.84587 11.1733 8.02776C11.8214 8.81173 12.7412 9.62601 13.9329 10.5501C16.8649 12.8183 18.7663 14.8316 18.9231 17.3267C18.9607 17.6633 18.9837 18.0072 18.9837 18.3553C18.9837 19.6232 18.7078 20.9654 18.2374 21.9093H18.2416C18.2416 21.9093 18.0398 22.2783 18.1663 22.3859C18.2311 22.4413 18.3712 22.4832 18.6158 22.3337C19.9291 21.4792 21.0596 20.3724 21.9419 19.0776C23.2422 17.161 23.9519 14.9052 23.9834 12.5894C24.0182 10.2734 23.3723 7.99817 22.1259 6.04587Z"
        fill="#F4732A"
      />
      <path
        d="M13.2309 14.5699L11.3944 13.0543C7.54766 10.2476 5.54697 7.22047 6.64348 3.48772C6.74278 3.14799 6.86508 2.81768 7.00515 2.49468V2.4905C7.00515 2.4905 7.27693 1.92082 6.68529 2.202C4.91077 3.16561 3.41323 4.5685 2.33598 6.27643C1.25874 7.98436 0.637831 9.94017 0.53268 11.9567C0.394481 14.5294 1.0991 17.0771 2.53965 19.2132C3.12133 20.03 3.83283 20.7461 4.64592 21.333H4.64278C8.69853 24.3184 12.1773 22.7473 12.1773 22.7473H12.1804C13.0431 22.3832 13.7787 21.7717 14.2942 20.99C14.8097 20.2083 15.082 19.2913 15.0769 18.355C15.0808 17.6247 14.9162 16.9033 14.5958 16.247C14.2755 15.5907 13.8081 15.0172 13.2299 14.571L13.2309 14.5699Z"
        fill="#092540"
      />
    </SvgLogo>
  );
};

const GoogleDriveLogo = (props: LogoComponentProps) => {
  return (
    <SvgLogo {...props}>
      <g clip-path="url(#clip0_100663_3693)">
        <path
          d="M1.81443 18.3655L2.87285 20.1924C3.09278 20.577 3.40893 20.8792 3.78007 21.099L7.56014 14.5605H0C0 14.9864 0.109966 15.4122 0.329897 15.7968L1.81443 18.3655Z"
          fill="#0066DA"
        />
        <path
          d="M12 6.86805L8.21993 0.32959C7.8488 0.54937 7.53265 0.851568 7.31271 1.23618L0.329897 13.3241C0.11401 13.7004 0.00028744 14.1266 0 14.5604H7.56014L12 6.86805Z"
          fill="#00AC47"
        />
        <path
          d="M20.2201 21.099C20.5912 20.8792 20.9074 20.577 21.1273 20.1924L21.5671 19.4369L23.6702 15.7968C23.8902 15.4122 24.0001 14.9864 24.0001 14.5605H16.4395L18.0483 17.7199L20.2201 21.099Z"
          fill="#EA4335"
        />
        <path
          d="M11.9998 6.86813L15.7799 0.32967C15.4087 0.10989 14.9826 0 14.5428 0H9.45684C9.01698 0 8.59086 0.123626 8.21973 0.32967L11.9998 6.86813Z"
          fill="#00832D"
        />
        <path
          d="M16.4401 14.5605H7.56034L3.78027 21.099C4.15141 21.3188 4.57752 21.4287 5.01739 21.4287H18.983C19.4229 21.4287 19.849 21.3051 20.2201 21.099L16.4401 14.5605Z"
          fill="#2684FC"
        />
        <path
          d="M20.1787 7.28014L16.6873 1.23618C16.4674 0.851568 16.1512 0.54937 15.7801 0.32959L12 6.86805L16.4399 14.5604H23.9863C23.9863 14.1345 23.8763 13.7087 23.6564 13.3241L20.1787 7.28014Z"
          fill="#FFBA00"
        />
      </g>
      <defs>
        <clipPath id="clip0_100663_3693">
          <rect width="24" height="21.4286" fill="white" />
        </clipPath>
      </defs>
    </SvgLogo>
  );
};

const GoogleDocLogo = (props: LogoComponentProps) => {
  return (
    <SvgLogo {...props}>
      <mask
        id="mask0_100663_3718"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="18"
        height="24"
      >
        <path
          d="M10.8462 0H1.62692C0.732115 0 0 0.736364 0 1.63636V22.3636C0 23.2636 0.732115 24 1.62692 24H15.7269C16.6217 24 17.3538 23.2636 17.3538 22.3636V6.54545L10.8462 0Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_100663_3718)">
        <path
          d="M10.8462 0H1.62692C0.732115 0 0 0.736364 0 1.63636V22.3636C0 23.2636 0.732115 24 1.62692 24H15.7269C16.6217 24 17.3538 23.2636 17.3538 22.3636V6.54545L13.5577 3.81818L10.8462 0Z"
          fill="#4285F4"
        />
      </g>
      <mask
        id="mask1_100663_3718"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="18"
        height="24"
      >
        <path
          d="M10.8462 0H1.62692C0.732115 0 0 0.736364 0 1.63636V22.3636C0 23.2636 0.732115 24 1.62692 24H15.7269C16.6217 24 17.3538 23.2636 17.3538 22.3636V6.54545L10.8462 0Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_100663_3718)">
        <path
          d="M11.3223 6.06641L17.3541 12.1319V6.54504L11.3223 6.06641Z"
          fill="url(#paint0_linear_100663_3718)"
        />
      </g>
      <mask
        id="mask2_100663_3718"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="18"
        height="24"
      >
        <path
          d="M10.8462 0H1.62692C0.732115 0 0 0.736364 0 1.63636V22.3636C0 23.2636 0.732115 24 1.62692 24H15.7269C16.6217 24 17.3538 23.2636 17.3538 22.3636V6.54545L10.8462 0Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask2_100663_3718)">
        <path
          d="M4.33789 17.4545H13.0148V16.3636H4.33789V17.4545ZM4.33789 19.6364H10.8456V18.5455H4.33789V19.6364ZM4.33789 12V13.0909H13.0148V12H4.33789ZM4.33789 15.2727H13.0148V14.1818H4.33789V15.2727Z"
          fill="#F1F1F1"
        />
      </g>
      <mask
        id="mask3_100663_3718"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="18"
        height="24"
      >
        <path
          d="M10.8462 0H1.62692C0.732115 0 0 0.736364 0 1.63636V22.3636C0 23.2636 0.732115 24 1.62692 24H15.7269C16.6217 24 17.3538 23.2636 17.3538 22.3636V6.54545L10.8462 0Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask3_100663_3718)">
        <path
          d="M10.8457 0V4.90909C10.8457 5.81318 11.5738 6.54545 12.4726 6.54545H17.3534L10.8457 0Z"
          fill="#A1C2FA"
        />
      </g>
      <mask
        id="mask4_100663_3718"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="18"
        height="24"
      >
        <path
          d="M10.8462 0H1.62692C0.732115 0 0 0.736364 0 1.63636V22.3636C0 23.2636 0.732115 24 1.62692 24H15.7269C16.6217 24 17.3538 23.2636 17.3538 22.3636V6.54545L10.8462 0Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask4_100663_3718)">
        <path
          d="M1.62692 0C0.732115 0 0 0.736364 0 1.63636V1.77273C0 0.872727 0.732115 0.136364 1.62692 0.136364H10.8462V0H1.62692Z"
          fill="white"
          fill-opacity="0.2"
        />
      </g>
      <mask
        id="mask5_100663_3718"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="18"
        height="24"
      >
        <path
          d="M10.8462 0H1.62692C0.732115 0 0 0.736364 0 1.63636V22.3636C0 23.2636 0.732115 24 1.62692 24H15.7269C16.6217 24 17.3538 23.2636 17.3538 22.3636V6.54545L10.8462 0Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask5_100663_3718)">
        <path
          d="M15.7269 23.8634H1.62692C0.732115 23.8634 0 23.1271 0 22.2271V22.3634C0 23.2634 0.732115 23.9998 1.62692 23.9998H15.7269C16.6217 23.9998 17.3538 23.2634 17.3538 22.3634V22.2271C17.3538 23.1271 16.6217 23.8634 15.7269 23.8634Z"
          fill="#1A237E"
          fill-opacity="0.2"
        />
      </g>
      <mask
        id="mask6_100663_3718"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="18"
        height="24"
      >
        <path
          d="M10.8462 0H1.62692C0.732115 0 0 0.736364 0 1.63636V22.3636C0 23.2636 0.732115 24 1.62692 24H15.7269C16.6217 24 17.3538 23.2636 17.3538 22.3636V6.54545L10.8462 0Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask6_100663_3718)">
        <path
          d="M12.4726 6.54506C11.5738 6.54506 10.8457 5.81278 10.8457 4.90869V5.04506C10.8457 5.94915 11.5738 6.68142 12.4726 6.68142H17.3534V6.54506H12.4726Z"
          fill="#1A237E"
          fill-opacity="0.1"
        />
      </g>
      <path
        d="M10.8462 0H1.62692C0.732115 0 0 0.736364 0 1.63636V22.3636C0 23.2636 0.732115 24 1.62692 24H15.7269C16.6217 24 17.3538 23.2636 17.3538 22.3636V6.54545L10.8462 0Z"
        fill="url(#paint1_radial_100663_3718)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_100663_3718"
          x1="312.946"
          y1="58.145"
          x2="312.946"
          y2="612.696"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#1A237E" stop-opacity="0.2" />
          <stop offset="1" stop-color="#1A237E" stop-opacity="0.02" />
        </linearGradient>
        <radialGradient
          id="paint1_radial_100663_3718"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(54.9778 47.1609) scale(2798.28 2798.28)"
        >
          <stop stop-color="white" stop-opacity="0.1" />
          <stop offset="1" stop-color="white" stop-opacity="0" />
        </radialGradient>
      </defs>
    </SvgLogo>
  );
};

const SharepointLogo = (props: LogoComponentProps) => {
  return (
    <SvgLogo {...props}>
      <path
        d="M12.2787 13.3581C15.9778 13.3581 18.9764 10.3678 18.9764 6.67904C18.9764 2.99031 15.9778 0 12.2787 0C8.57971 0 5.58105 2.99031 5.58105 6.67904C5.58105 10.3678 8.57971 13.3581 12.2787 13.3581Z"
        fill="#036C70"
      />
      <path
        d="M17.8602 18.9236C21.251 18.9236 23.9998 16.1825 23.9998 12.8012C23.9998 9.41982 21.251 6.67871 17.8602 6.67871C14.4695 6.67871 11.7207 9.41982 11.7207 12.8012C11.7207 16.1825 14.4695 18.9236 17.8602 18.9236Z"
        fill="#1A9BA1"
      />
      <path
        d="M13.1163 23.3765C15.7364 23.3765 17.8604 21.2584 17.8604 18.6455C17.8604 16.0327 15.7364 13.9146 13.1163 13.9146C10.4961 13.9146 8.37207 16.0327 8.37207 18.6455C8.37207 21.2584 10.4961 23.3765 13.1163 23.3765Z"
        fill="#37C6D0"
      />
      <path
        opacity="0.1"
        d="M13.3954 6.01113V17.8664C13.3954 18.256 13.1163 18.6456 12.7814 18.8126C12.614 18.9239 12.5023 18.9239 12.3907 18.9239H8.3721C8.3721 18.8126 8.3721 18.757 8.3721 18.6456C8.3721 18.5343 8.3721 18.4787 8.3721 18.3673C8.48373 16.5863 9.60001 15.0278 11.2186 14.3043V13.2468C7.5907 12.6902 5.07908 9.23933 5.63722 5.62152V5.56586C5.63722 5.39889 5.69303 5.17625 5.74884 5.00928H12.3349C12.9488 5.00928 13.3954 5.45455 13.3954 6.01113Z"
        fill="black"
      />
      <path
        opacity="0.2"
        d="M11.8323 5.56592H5.69272C5.07876 9.18373 7.53458 12.6346 11.1625 13.2468C11.2741 13.2468 11.3857 13.3025 11.4974 13.3025C9.76714 14.1373 8.48342 16.4193 8.37179 18.3674C8.37179 18.4787 8.37179 18.5344 8.37179 18.6457C8.37179 18.757 8.37179 18.8127 8.37179 18.924C8.37179 19.091 8.4276 19.3136 8.4276 19.4806H11.7764C12.1671 19.4806 12.5578 19.2023 12.7253 18.8683C12.7811 18.757 12.7811 18.59 12.7811 18.4787V6.56777C12.8369 6.01119 12.3904 5.56592 11.8323 5.56592Z"
        fill="black"
      />
      <path
        opacity="0.2"
        d="M11.8323 5.56592H5.69272C5.07876 9.18373 7.53458 12.6346 11.1625 13.2468C11.2183 13.2468 11.3299 13.2468 11.3857 13.3025C9.71132 14.193 8.48342 16.475 8.37179 18.3674H11.7764C12.3346 18.3674 12.7811 17.9221 12.7811 17.3655V6.56777C12.8369 6.01119 12.3904 5.56592 11.8323 5.56592Z"
        fill="black"
      />
      <path
        opacity="0.2"
        d="M11.2747 5.56592H5.69335C5.13521 9.01675 7.25614 12.3006 10.6608 13.1355C9.37707 14.5826 8.59567 16.4193 8.42823 18.3674H11.2747C11.8329 18.3674 12.2794 17.9221 12.2794 17.3655V6.56777C12.2794 6.01119 11.8329 5.56592 11.2747 5.56592Z"
        fill="black"
      />
      <path
        d="M1.00465 5.56592H11.2186C11.7767 5.56592 12.2233 6.01119 12.2233 6.56777V16.7533C12.2233 17.3099 11.7767 17.7552 11.2186 17.7552H1.00465C0.446512 17.7552 0 17.3099 0 16.7533V6.56777C0 6.01119 0.446512 5.56592 1.00465 5.56592Z"
        fill="url(#paint0_linear_100663_3809)"
      />
      <path
        d="M4.57632 11.5768C4.35306 11.4098 4.12981 11.1872 4.01818 10.9646C3.85074 10.6863 3.79492 10.408 3.79492 10.1297C3.79492 9.74008 3.90655 9.35047 4.18562 9.01651C4.46469 8.68256 4.79957 8.45993 5.19027 8.34861C5.63678 8.18163 6.08329 8.12598 6.58562 8.12598C7.19957 8.12598 7.81353 8.18164 8.37167 8.40427V9.68442C8.0926 9.51744 7.81353 9.40612 7.53446 9.35047C7.19957 9.29481 6.9205 9.23915 6.58562 9.23915C6.25074 9.23915 5.91585 9.29481 5.58097 9.46178C5.35771 9.5731 5.19027 9.79574 5.19027 10.074C5.19027 10.241 5.24608 10.3523 5.35771 10.5193C5.46934 10.6306 5.63678 10.7419 5.80422 10.8532C5.97167 10.9646 6.25074 11.0759 6.64143 11.2429C6.69725 11.2429 6.69725 11.2985 6.75306 11.2985C7.14376 11.4655 7.47864 11.6325 7.81353 11.7994C8.0926 11.9664 8.26004 12.1891 8.42748 12.4117C8.59492 12.69 8.65074 13.0239 8.65074 13.3579C8.65074 13.7475 8.53911 14.1928 8.31585 14.4711C8.0926 14.7494 7.75771 14.972 7.36701 15.0833C6.9205 15.1946 6.47399 15.3059 6.02748 15.3059C5.63678 15.3059 5.19027 15.2503 4.79957 15.1946C4.46469 15.139 4.12981 15.0276 3.79492 14.9163V13.5805C4.07399 13.8032 4.46469 13.9701 4.79957 14.0814C5.13446 14.1928 5.52515 14.2484 5.91585 14.2484C6.25074 14.2484 6.58562 14.1928 6.9205 14.0258C7.14376 13.9145 7.25539 13.6918 7.25539 13.4135C7.25539 13.2466 7.19957 13.0796 7.08794 12.9683C6.9205 12.8013 6.75306 12.69 6.58562 12.5787C6.36236 12.4673 6.02748 12.3004 5.58097 12.1334C5.19027 11.9664 4.85539 11.7438 4.57632 11.5768Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_100663_3809"
          x1="2.1331"
          y1="4.76872"
          x2="10.1125"
          y2="18.6273"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#058F92" />
          <stop offset="0.5" stop-color="#038489" />
          <stop offset="1" stop-color="#026D71" />
        </linearGradient>
      </defs>
    </SvgLogo>
  );
};

const ConfluenceLogo = (props: LogoComponentProps) => {
  return (
    <SvgLogo {...props}>
      <path
        d="M0.870214 17.7626C0.621995 18.1674 0.343227 18.6371 0.106464 19.0114C0.00459266 19.1835 -0.0256743 19.3888 0.0221687 19.583C0.0700118 19.7772 0.192146 19.9449 0.36232 20.0501L5.32669 23.1051C5.41296 23.1583 5.50897 23.1939 5.60912 23.2096C5.70926 23.2254 5.81155 23.2211 5.91001 23.1969C6.00847 23.1728 6.10114 23.1292 6.1826 23.0689C6.26406 23.0085 6.33269 22.9325 6.38449 22.8454C6.58306 22.5132 6.83892 22.0816 7.11768 21.6196C9.08434 18.3736 11.0624 18.7708 14.6292 20.4739L19.5515 22.8148C19.6438 22.8588 19.744 22.8837 19.846 22.8882C19.9481 22.8927 20.0501 22.8767 20.1459 22.8411C20.2417 22.8055 20.3293 22.751 20.4037 22.6809C20.4781 22.6108 20.5376 22.5265 20.5788 22.433L22.9426 17.0867C23.0228 16.9032 23.0278 16.6955 22.9564 16.5083C22.8849 16.3212 22.7428 16.1696 22.5607 16.0862C21.522 15.5974 19.4561 14.6236 17.5963 13.7262C10.9059 10.4765 5.21977 10.6865 0.870214 17.7626Z"
        fill="url(#paint0_linear_100663_3832)"
      />
      <path
        d="M23.1302 5.63043C23.3784 5.22564 23.6571 4.75594 23.8939 4.3817C23.9958 4.20955 24.026 4.0043 23.9782 3.81007C23.9304 3.61584 23.8082 3.44814 23.6381 3.343L18.6737 0.288001C18.5868 0.229464 18.4887 0.189437 18.3857 0.17041C18.2827 0.151384 18.1768 0.153765 18.0747 0.177406C17.9726 0.201046 17.8765 0.245441 17.7923 0.307826C17.7081 0.370212 17.6377 0.449255 17.5853 0.540038C17.3868 0.872269 17.1309 1.30379 16.8521 1.76586C14.8855 5.01179 12.9074 4.61464 9.34066 2.91148L4.43357 0.582044C4.34129 0.538124 4.24114 0.513169 4.13905 0.508657C4.03695 0.504146 3.93499 0.520169 3.8392 0.555778C3.74341 0.591388 3.65574 0.645859 3.58139 0.715966C3.50703 0.786072 3.4475 0.870388 3.40632 0.963919L1.04252 6.31017C0.962247 6.4937 0.957293 6.70142 1.02872 6.88856C1.10015 7.07571 1.24225 7.22731 1.42439 7.31068C2.46309 7.79948 4.52904 8.77326 6.38877 9.67066C13.0945 12.9166 18.7806 12.6989 23.1302 5.63043Z"
        fill="url(#paint1_linear_100663_3832)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_100663_3832"
          x1="22.8089"
          y1="24.6822"
          x2="7.78978"
          y2="16.0518"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.18" stop-color="#0052CC" />
          <stop offset="1" stop-color="#2684FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_100663_3832"
          x1="1.19145"
          y1="-1.29296"
          x2="16.2144"
          y2="7.34123"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.18" stop-color="#0052CC" />
          <stop offset="1" stop-color="#2684FF" />
        </linearGradient>
      </defs>
    </SvgLogo>
  );
};

// Logo MAP - maps logo names to their components
const LOGO_MAP = {
  ZoomInfo: ZoomInfoLogo,
  Drive: DriveLogo,
  Notion: NotionLogo,
  Zapier: ZapierLogo,
  Octalane: OctalaneLogo,
  Shopify: ShopifyLogo,
  Slack: SlackLogo,
  Clay: ClayLogo,
  Appolo: AppoloLogo,
  Attio: AttioLogo,
  Hubspot: HubspotLogo,
  Salesforce: SalesforceLogo,
  Calendly: CalendlyLogo,
  Whatsapp: WhatsappLogo,
  Instagram: InstagramLogo,
  iMessage: iMessageLogo,
  LINE: LINELogo,
  FacebookMessenger: FacebookMessengerLogo,
  Google: GoogleLogo,
  Wati: WatiLogo,
  Folk: FolkLogo,
  Linkedin: LinkedinLogo,
  Claude: ClaudeLogo,
  GPT: GPTLogo,
  Calcom: CalcomLogo,
  Astra: AstraLogo,
  Clearbit: ClearbitLogo,
  GoogleCalendar: GoogleCalendarLogo,
  GoogleMail: GoogleMailLogo,
  Factorsai: FactorsaiLogo,
  Builtwith: BuiltwithLogo,
  Similarweb: SimilarwebLogo,
  GoogleDrive: GoogleDriveLogo,
  GoogleDoc: GoogleDocLogo,
  Sharepoint: SharepointLogo,
  Confluence: ConfluenceLogo
} as const;

type LogoName = keyof typeof LOGO_MAP;

type LogoProps = React.SVGProps<SVGSVGElement> & {
  name: LogoName;
  size?: number;
  strokeWidth?: number;
};

export function Logo({
  name,
  size = 24,
  strokeWidth = 1.2,
  ...rest
}: LogoProps) {
  const Comp = LOGO_MAP[name];
  if (!Comp) return null;

  // 对于图片组件，只传递 size 属性
  if (name === "Zapier" || name === "Clay" || name === "Instagram") {
    return <Comp size={size} />;
  }

  // For all SVG-based logos, pass size directly
  return <Comp size={size} strokeWidth={strokeWidth} {...rest} />;
}

export const LOGO_NAMES: LogoName[] = Object.keys(LOGO_MAP) as LogoName[];

// Export all logo components for direct import
export {
  ZoomInfoLogo,
  DriveLogo,
  NotionLogo,
  ZapierLogo,
  OctalaneLogo,
  ShopifyLogo,
  SlackLogo,
  ClayLogo,
  AppoloLogo,
  AttioLogo,
  HubspotLogo,
  SalesforceLogo,
  CalendlyLogo,
  WhatsappLogo,
  InstagramLogo,
  iMessageLogo,
  LINELogo,
  FacebookMessengerLogo,
  GoogleLogo,
  WatiLogo,
  FolkLogo,
  LinkedinLogo,
  ClaudeLogo,
  GPTLogo,
  CalcomLogo,
  AstraLogo,
  ClearbitLogo,
  GoogleCalendarLogo,
  GoogleMailLogo,
  FactorsaiLogo,
  BuiltwithLogo,
  SimilarwebLogo,
  GoogleDocLogo,
  SharepointLogo,
  ConfluenceLogo
};

// Re-export types for better module resolution
export type { LogoName, LogoProps };
